<template>
  <div>
    <!-- آیتم های سربرگ سند -->
    <div class="row border rounded shadow-light px-2">
      <!-- ستون اول : شماره سند + شناسه سند -->
      <div class="col-lg-2 col-md-3 col-sm-4 d-flex flex-column p-1">
        <div class="row mt-1">
          <div class="
              col-0-half
              d-flex
              justify-content-end
              align-items-center
              p-0
              pl-1
            ">
            شمـــــاره
          </div>
          <div class="col d-flex justify-content-start align-items-center p-0">
            <div class="input-group">
              <input type="text" class="form-control form-control-sm" v-bind:disabled="checkDisabledDocID"
                v-model="AccDocData.NDocNu" v-on:focus="
                  $event.target.select();
                ArrowKeyEnable = false;
                HideFilterModal();
                " v-on:blur="ArrowKeyEnable = true" v-on:keyup.enter="SearchNIdNDocNuInServer(0, AccDocData.NDocNu)"
                v-on:keyup.down="
                  SearchNIdNDocNuInServer(0, AccDocData.NDocNu - 1)
                  " v-on:keyup.up="
    SearchNIdNDocNuInServer(0, AccDocData.NDocNu + 1)
    " v-on:keyup="
    $event.target.value = $event.target.value.replace(
      /[^0-9]/g,
      ''
    )
    " />
              <!-- v-on:input="setChangeAccDocData" -->
              <!-- عدم وجود تغییرات در سند - امکان تغییر شماره وجود دارد -->
              <div v-if="!checkDisabledDocID" class="input-group-prepend rounded-0">
                <span class="
                    input-group-text input-group-box-size
                    d-flex
                    flex-column
                    bg-default
                  ">
                  <a class="p-0 m-0" style="line-height: 0; font-size: 10px; width: 100%" v-on:click="
                    SearchNIdNDocNuInServer(0, AccDocData.NDocNu + 1)
                    " title="شماره بعدی">
                    <i class="fas fa-caret-up white-text" aria-hidden="true"></i>
                  </a>
                  <a class="p-0 m-0" style="line-height: 0; font-size: 10px; width: 100%" v-on:click="
                    SearchNIdNDocNuInServer(0, AccDocData.NDocNu - 1)
                    " title="شماره قبلی">
                    <i class="fas fa-caret-down white-text" aria-hidden="true"></i>
                  </a>
                </span>
                <span class="
                    input-group-text input-group-box-size
                    bg-secondary
                    rounded-left
                  ">
                  <a v-on:click="
                    SearchNIdNDocNuInServer(AccDocData.NId, AccDocData.NDocNu)
                    ">
                    <i class="fas fa-search white-text" aria-hidden="true"></i>
                  </a>
                </span>
              </div>
              <!-- به علت وجود تغییرات در سند امکان تغییر در شماره نیست -->
              <div v-else class="input-group-prepend rounded-0">
                <span class="
                    input-group-text input-group-box-size
                    d-flex
                    flex-column
                    bg-default
                  ">
                  <i class="fas fa-caret-up white-text" style="font-size: 10px" aria-hidden="true"></i>
                  <i class="fas fa-caret-down white-text" style="font-size: 10px" aria-hidden="true"></i>
                </span>
                <span class="
                    input-group-text input-group-box-size
                    bg-secondary
                    rounded-left
                  ">
                  <i class="fas fa-search white-text" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="
              col-0-half
              d-flex
              justify-content-end
              align-items-center
              p-0
              pl-1
            ">
            شناســه
          </div>
          <div class="col d-flex justify-content-start align-items-center my-1 p-0">
            <div class="input-group">
              <input type="text" class="form-control form-control-sm" v-bind:disabled="checkDisabledDocID"
                v-model="AccDocData.NId" v-on:focus="
                  $event.target.select();
                ArrowKeyEnable = false;
                HideFilterModal();
                " v-on:blur="ArrowKeyEnable = true" v-on:keyup.enter="SearchNIdNDocNuInServer(AccDocData.NId, 0)"
                v-on:keyup.down="SearchNIdNDocNuInServer(AccDocData.NId - 1, 0)"
                v-on:keyup.up="SearchNIdNDocNuInServer(AccDocData.NId + 1, 0)" v-on:keyup="
                  $event.target.value = $event.target.value.replace(
                    /[^0-9]/g,
                    ''
                  )
                  " />
              <!-- v-on:input="setChangeAccDocData" -->
              <!-- عدم وجود تغییرات در سند - امکان تغییر شماره وجود دارد -->
              <div v-if="!checkDisabledDocID" class="input-group-prepend rounded-0">
                <span class="
                    input-group-text input-group-box-size
                    d-flex
                    flex-column
                    bg-default
                  ">
                  <a class="p-0 m-0" style="line-height: 0; font-size: 10px; width: 100%"
                    v-on:click="SearchNIdNDocNuInServer(AccDocData.NId + 1, 0)" title="شناسه بعدی">
                    <i class="fas fa-caret-up white-text" aria-hidden="true"></i>
                  </a>
                  <a class="p-0 m-0" style="line-height: 0; font-size: 10px; width: 100%"
                    v-on:click="SearchNIdNDocNuInServer(AccDocData.NId - 1, 0)" title="شناسه قبلی">
                    <i class="fas fa-caret-down white-text" aria-hidden="true"></i>
                  </a>
                </span>
                <span class="
                    input-group-text input-group-box-size
                    bg-secondary
                    rounded-left
                  ">
                  <a v-on:click="
                    SearchNIdNDocNuInServer(AccDocData.NId, AccDocData.NDocNu)
                    ">
                    <i class="fas fa-search white-text" aria-hidden="true"></i>
                  </a>
                </span>
              </div>
              <!-- به علت وجود تغییرات در سند امکان تغییر در شماره نیست -->
              <div v-else class="input-group-prepend rounded-0">
                <span class="
                    input-group-text input-group-box-size
                    d-flex
                    flex-column
                    bg-default
                  ">
                  <i class="fas fa-caret-up white-text" style="font-size: 10px" aria-hidden="true"></i>
                  <i class="fas fa-caret-down white-text" style="font-size: 10px" aria-hidden="true"></i>
                </span>
                <span class="
                    input-group-text input-group-box-size
                    bg-secondary
                    rounded-left
                  ">
                  <i class="fas fa-search white-text" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ستون دوم : تاریخ + نوع + سازمان + شرح -->
      <div class="col-lg-10 col-sm-12 d-flex flex-column p-1 pr-lg-3">
        <!-- سطر اول : تاریخ + نوع + سازمان -->
        <div class="row">
          <!-- تاریخ سند -->
          <div class="
              col-md-3 col-sm-6
              d-flex
              justify-content-start
              align-items-center
              m-0
              p-0
            ">
            <div class="
                col-0-half
                d-flex
                justify-content-end
                align-items-center
                ml-2
              " v-bind:style="AlarmNotSetDate == true ? 'color: red;' : 'color: inherit;'
                ">
              تاریـــــخ
            </div>
            <div class="col d-flex justify-content-end align-items-center p-0">
              <date-picker color="#7E489C" input-class="form-control form-control-sm rounded-0"
                :element="'my-custom-input-' + tabData.TabID" :name="'datapicker-' + tabData.TabID"
                v-on:input="setChangeAccDocData" v-model="SDocDateTemp"></date-picker>
              <div class="input-group">
                <!-- این اینپوت سفارشی و جهت نمایش تاریخ طراحی شده است -->
                <!-- از کتابخانه VueTheMask -->
                <the-mask type="text" class="form-control form-control-sm rounded-0" v-bind:style="AlarmNotSetDate == true
                  ? 'background-color: rgb(255, 181, 189);'
                  : 'background-color: inherit;'
                  " :mask="['####/##/##']" :masked="true" :id="'the-mask-input-' + tabData.TabID"
                  v-on:keyup.enter.native="showDatePicker(tabData.TabID)" v-on:keyup.down.native="getDateShamsi(false)"
                  v-on:keyup.up.native="getDateShamsi(true)" v-on:input="setChangeAccDocData" v-on:focus.native="
                    ArrowKeyEnable = false;
                  HideFilterModal();
                  " v-on:blur.native="checkDateFormat" v-model="SDocDateTemp" />
                <div class="input-group-prepend rounded-0">
                  <span class="
                      input-group-text input-group-box-size
                      bg-secondary
                      rounded-left
                    " v-bind:style="AlarmNotSetDate == true
                      ? 'background-color: #dc3545 !important;'
                      : 'background-color: inherit;'
                      ">
                    <a :id="'my-custom-input-' + tabData.TabID">
                      <i class="far fa-calendar-alt white-text" aria-hidden="true"></i>
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- نوع سند -->
          <div class="
              col-md-3 col-sm-6
              d-flex
              justify-content-start
              align-items-center
              m-0
              p-0
            ">
            <div class="
                col-0-half
                d-flex
                justify-content-end
                align-items-center
                ml-2
                mr-2
              ">
              نـــوع
            </div>
            <div class="col d-flex justify-content-start align-items-center p-0">
              <div class="input-group">
                <select class="form-control form-control-sm rounded-0" v-model="AccDocData.NDocType"
                  v-on:change="setChangeAccDocData" v-on:focus="
                    ArrowKeyEnable = false;
                  HideFilterModal();
                  " v-on:blur="ArrowKeyEnable = true" v-bind:disabled="getTbBaseDocTypeData.length == 1">
                  <option v-for="option in getTbBaseDocTypeData" v-bind:key="option.NCode" v-bind:value="option.NCode">
                    {{ option.SDesc }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <!-- سازمان -->
          <div class="
              col-md-6 col-sm-12
              d-flex
              justify-content-start
              align-items-center
              my-sm-1
              p-0
            ">
            <div class="
                col-0-half
                d-flex
                justify-content-end
                align-items-center
                ml-1
                mr-md-2
              ">
              سازمان
            </div>
            <div class="col d-flex justify-content-start align-items-center p-0">
              <div class="input-group">
                <select class="form-control form-control-sm rounded-0" v-model="AccDocData.NOrgCode"
                  v-on:change="setChangeAccDocData" v-on:focus="
                    ArrowKeyEnable = false;
                  HideFilterModal();
                  " v-on:blur="ArrowKeyEnable = true" v-bind:disabled="getTbBaseOrgData.length == 1">
                  <option v-for="option in getTbBaseOrgData" v-bind:key="option.NCode" v-bind:value="option.NCode">
                    {{ option.SDesc }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <!-- سطر دوم : شرح سند -->
        <div class="row">
          <div class="
              col-0-half
              d-flex
              justify-content-start
              align-items-center
              ml-2
            ">
            شــــــرح
          </div>
          <div class="col p-0">
            <div class="input-group">
              <input class="form-control form-control-sm" type="text" v-bind:id="'txtSDocDesc' + tabIDInChild"
                v-model="AccDocData.SDocDesc" v-on:input="setChangeAccDocData" v-on:focus="
                  $event.target.select();
                HideFilterModal();
                showFilterSDocDesc($event);
                " v-on:keyup.backspace="showFilterSDocDesc($event)" />
              <!-- v-on:blur="isShowFilterSDocDesc = false;" -->
              <div class="input-group-prepend rounded-0">
                <span class="
                    input-group-text input-group-box-size
                    bg-secondary
                    rounded-left
                    d-flex
                    flex-column
                    justify-content-around
                    align-items-center
                  ">
                  <i class="fas fa-trash-alt white-text" aria-hidden="true"></i>
                </span>
              </div>
            </div>
            <keep-alive>
              <filter-sdocdesc v-if="isShowFilterSDocDesc" v-bind:FilterSDesc="AccDocData.SDocDesc"
                v-bind:LocationShow="LocationShowFilterSDocDesc" v-on:HideFilter="HideFilterSDocDesc"></filter-sdocdesc>
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
    <!-- جدول محتویات سند -->
    <div class="row mt-3" v-on:click="HideShowFilterSDocDesc()">
      <div class="col p-0">
        <!-- تب های سربرگ محتویات سند -->
        <ul class="nav nav-tabs">
          <!-- تب مشخصات سند -->
          <li class="nav-item activeNav rounded-top">
            <a href="#tabDoc" id="home-tab" class="
                nav-link
                active
                d-flex
                justify-content-between
                align-items-center
              " data-toggle="tab">
              مشخصات سند
            </a>
          </li>
          <!-- تب اطلاعات تکمیلی -->
          <!-- <li class="nav-item rounded-top">
            <a
              href="#tabInfo"
              id="profile-tab"
              class="nav-link d-flex justify-content-between align-items-center"
              data-toggle="tab"
            >
              اطلاعات تکمیلی
            </a>
          </li> -->
        </ul>

        <!-- بدنه محتویات سند -->
        <div class="tab-content rounded shadow z-depth-1 p-1">
          <!-- بدنه مشخصات سند -->
          <div class="tab-pane fade show active w-100" id="tabDoc">
            <!-- جدول محتویات -->
            <div class="row p-2">
              <div class="table-responsive" style="scroll-y: auto; height: 48vh;">
                <table class="
                    table table-bordered table-sm
                    text-center
                    table-font-size
                  ">
                  <!-- سربرگ جدول -->
                  <thead class="text-light bg-secondary" style="height: 30px; top: 0; position: sticky; ">
                    <!-- ردیف -->
                    <td style="
                        width: 85px !important;
                        min-width: 85px !important;
                        max-width: 85px !important;
                      ">
                      <div class="d-flex justify-content-around align-items-center">
                        <!-- انتقال به سطر انتهایی -->
                        <a v-if="AccDocData.ListTbAccDocRecord.length > 5" title="مشاهده سطر انتهایی" class="d-flex"
                          v-on:click="scrollTable('LastRowAccDoc')">
                          <i data-v-40331621="" class="far fa-arrow-alt-circle-down fa-1x-half text-light"></i>
                        </a>
                        <!-- درج سطر جدید -->
                        <a v-if="checkNewRow == false" v-on:click="callNewRow()" title="سطر جدید (Alt+n)"
                          class="d-flex"><i class="
                              fas
                              fa-plus-circle fa-1x-half
                              text text-light
                            "></i></a>
                        <a title="مرتب سازی ردیف" v-on:click="updateNIOId">
                          <i class="fas fa-sort-numeric-down fa-lg hover"></i>
                        </a>
                        <!-- <a v-on:click="updateNIOId">ردیف</a> -->
                        <!-- <a v-on:click="deleteRow()" title="حذف همه (Alt+d)"
                          ><i class="fas fa-trash-alt fa-lg m-1 text-white"></i
                        ></a> -->
                      </div>
                    </td>
                    <!-- کد حساب -->
                    <td>
                      <div class="
                          row
                          d-flex
                          justify-content-around
                          align-items-center
                        ">
                        <a title="مرتب سازی کد حساب" v-on:click="sortDocRow('NAccCode', '')">
                          <i class="fas fa-sort-numeric-down fa-lg hover"></i>
                        </a>
                        <span>کد حساب</span>
                        <a title="مرتب سازی عنوان کد حساب" v-on:click="sortDocRow('SAccCode', '')">
                          <i class="fas fa-sort-alpha-down fa-lg hover"></i>
                        </a>
                      </div>
                    </td>
                    <!-- طرف حساب -->
                    <td>
                      <div class="
                          row
                          d-flex
                          justify-content-around
                          align-items-center
                        ">
                        <a title="مرتب سازی کد طرف حساب" v-on:click="sortDocRow('NPerID', '')">
                          <i class="fas fa-sort-numeric-down fa-lg hover"></i>
                        </a>
                        <span>طرف حساب</span>
                        <a title="مرتب سازی عنوان طرف حساب" v-on:click="sortDocRow('LName', '')">
                          <i class="fas fa-sort-alpha-down fa-lg hover"></i>
                        </a>
                      </div>
                    </td>
                    <!-- مرکز هزینه -->
                    <td>
                      <div class="
                          row
                          d-flex
                          justify-content-around
                          align-items-center
                        ">
                        <a title="مرتب سازی کد مرکز هزینه" v-on:click="sortDocRow('NUsePlace', '')">
                          <i class="fas fa-sort-numeric-down fa-lg hover"></i>
                        </a>
                        <span>مرکز هزینه</span>
                        <a title="مرتب سازی عنوان مرکز هزینه" v-on:click="sortDocRow('SUsePlace', '')">
                          <i class="fas fa-sort-alpha-down fa-lg hover"></i>
                        </a>
                      </div>
                    </td>
                    <!-- قراردادها -->
                    <td>
                      <div class="
                          row
                          d-flex
                          justify-content-around
                          align-items-center
                        ">
                        <a title="مرتب سازی کد قراردادها" v-on:click="sortDocRow('NAgrID', '')">
                          <i class="fas fa-sort-numeric-down fa-lg hover"></i>
                        </a>
                        <span>قراردادها</span>
                        <a title="مرتب سازی عنوان قراردادها" v-on:click="sortDocRow('SAgreement', '')">
                          <i class="fas fa-sort-alpha-down fa-lg hover"></i>
                        </a>
                      </div>
                    </td>
                    <!-- بدهکار -->
                    <td style="min-width: 80px !important">
                      <div class="
                          row
                          d-flex
                          justify-content-around
                          align-items-center
                        ">
                        <a title="مرتب سازی بدهکار" v-on:click="sortDocRow('NDebit', '')">
                          <i class="fas fa-sort-numeric-down fa-lg hover"></i>
                        </a>
                        <span>بدهکار</span>
                      </div>
                    </td>
                    <!-- بستانکار -->
                    <td style="min-width: 80px !important">
                      <div class="
                          row
                          d-flex
                          justify-content-around
                          align-items-center
                        ">
                        <a title="مرتب سازی بستانکار" v-on:click="sortDocRow('NCredit', '')">
                          <i class="fas fa-sort-numeric-down fa-lg hover"></i>
                        </a>
                        <span>بستانکار</span>
                      </div>
                    </td>
                  </thead>

                  <!-- بدنه جدول -->
                  <tbody>
                    <!-- درج سطر جدید -->
                    <tr v-if="checkNewRow" class="bg-danger-light rowBoxShadow">
                      <td rowspan="2" class="text-danger">
                        <div class="
                            d-flex
                            flex-column
                            justify-content-center
                            align-items-center
                          ">
                          <div>
                            <a v-if="invalidEditCheck(
                              newNAccCode_NCode,
                              newNPerID_NPerID
                            ).state
                              " v-on:click="saveNewRow()" title="ذخیره (Alt+s)"><i
                                class="fas fa-save fa-lg m-1 text-primary"></i></a>
                            <a v-on:click="cancelNewRow" title="انصراف (Alt+c)"><i
                                class="fas fa-ban fa-lg m-1 text-danger"></i></a>
                          </div>
                          <span>جدید</span>
                        </div>
                      </td>
                      <!-- سطر جدید - کد حساب -->
                      <td style="vertical-align: text-top !important">
                        <div class="row shortText">
                          <div class="input-group px-1">
                            <input 
                              type="text" 
                              autocomplete="off" 
                              id="textHesabCode" 
                              class="
                                form-control form-control-sm
                                rounded-0
                                text-center
                              " 
                              :class="{ invalid: newNAccCode_NCode_Invalid }" 
                              style="direction: ltr"
                              v-model="newNAccCode_NCode" 
                              v-on:focus="
                                $event.target.select(); 
                                HideFilterModal(); 
                                onlyNumberAndFilterHesabCode();
                                " 
                              v-on:blur="getTbBaseAccDescDataName()"
                              v-on:keyup.enter="ManageFocusText('NCode', true)"
                              v-on:keypress="onlyNumberAndFilterHesabCode"
                              title="فشردن + : نمایش لیست کامل"
                            />
                            <div class="input-group-prepend rounded-0">
                              <span class="
                                  input-group-text input-group-box-size
                                  bg-danger
                                  rounded-left
                                  white-text
                                ">
                                <a v-on:click="ShowModal('HesabCode', true)">
                                  <i class="fas fa-bars fa-sm" aria-hidden="true"></i>
                                </a>
                                <keep-alive>
                                  <modal-hesab-code v-if="isShowModalHesabCode"
                                    v-on:HideModal="HideModalHesabCode"></modal-hesab-code>
                                </keep-alive>
                              </span>
                            </div>
                          </div>
                          <span class="w-100 text-center text-dark h12">
                            {{ getHesabNameByNewOrEditRow(newNAccCode_NCode) }}
                          </span>
                          <filter-hesab-code 
                            v-if="isShowFilterHesabCode" 
                            v-bind:RandomNumberChild="RandomNumber" 
                            v-bind:HesabCode="newNAccCode_NCode"
                            v-on:HideFilterHesab="HideModalHesabCode"
                          ></filter-hesab-code>
                        </div>
                      </td>
                      <!-- سطر جدید - طرف حساب -->
                      <td style="vertical-align: text-top !important">
                        <div class="row shortText">
                          <div class="input-group px-1">
                            <input 
                              type="text" 
                              autocomplete="off" 
                              id="textTarafHesab" 
                              class="
                                form-control 
                                form-control-sm
                                rounded-0
                                text-center
                              " 
                              :class="{ invalid: newNPerID_NPerID_Invalid }" 
                              style="direction: ltr"
                              v-model="newNPerID_NPerID" 
                              v-on:focus="$event.target.select(); HideFilterModal(); onlyNumberAndFilterTarafHesab()" 
                              v-on:keyup.enter="ManageFocusText('BaseUsePlace', true)" 
                              v-on:keypress="onlyNumberAndFilterTarafHesab" 
                              :disabled="checkDisabledTarafHesab" 
                              title="فشردن + : نمایش لیست کامل"
                            />
                            <div class="input-group-prepend rounded-0">
                              <span class="
                                  input-group-text input-group-box-size
                                  bg-danger
                                  rounded-left
                                  white-text
                                ">
                                <a v-on:click="ShowModal('TarafHesab', true)" v-if="!checkDisabledTarafHesab">
                                  <i class="fas fa-bars fa-sm" aria-hidden="true"></i>
                                </a>
                                <i v-else class="fas fa-bars fa-sm" aria-hidden="true"></i>

                                <keep-alive>
                                  <modal-taraf-hesab v-if="isShowModalTarafHesab" v-bind:NAccType="newNAccCode_NAccType"
                                    v-on:HideModal="HideModalTarafHesab"></modal-taraf-hesab>
                                </keep-alive>
                              </span>
                            </div>
                          </div>
                          <span class="w-100 text-center text-dark h12">
                            {{ getTarafHesabName(newNPerID_NPerID) }}
                          </span>
                          <filter-taraf-hesab 
                            v-if="isShowFilterTarafHesab" 
                            v-bind:RandomNumberChild="RandomNumber" 
                            v-bind:TarafCode="newNPerID_NPerID"
                            v-bind:NAccType="newNAccCode_NAccType"
                            v-on:HideFilterTarafHesab="HideModalTarafHesab"></filter-taraf-hesab>
                        </div>
                      </td>
                      <!-- سطر جدید - مرکز هزینه -->
                      <td style="vertical-align: text-top !important">
                        <div class="row shortText">
                          <div class="input-group px-1">
                            <input type="text" autocomplete="off" id="textBaseUsePlace" class="
                                form-control form-control-sm
                                rounded-0
                                text-center
                              " :class="{
                                invalid: newBaseUserPlace_NCode_Invalid,
                              }" style="direction: ltr" 
                              v-model="newBaseUserPlace_NCode" 
                              v-on:focus="$event.target.select(); HideFilterModal(); onlyNumberAndFilterBaseUsePlace()" 
                              v-on:keyup.enter="ManageFocusText('BaseAgreement', true)" 
                              v-on:keypress="onlyNumberAndFilterBaseUsePlace" 
                              :disabled="checkDisabledMarkazHazine" 
                              title="فشردن + : نمایش لیست کامل"
                            />
                            <div class="input-group-prepend rounded-0">
                              <span class="
                                  input-group-text input-group-box-size
                                  bg-danger
                                  rounded-left
                                  white-text
                                ">
                                <a v-on:click="ShowModal('BaseUsePlace', true)" v-if="!checkDisabledMarkazHazine">
                                  <i class="fas fa-bars fa-sm" aria-hidden="true"></i>
                                </a>
                                <i v-else class="fas fa-bars fa-sm" aria-hidden="true"></i>

                                <modal-base-useplace 
                                  v-if="isShowModalBaseUsePlace"
                                  v-on:HideModal="HideModalBaseUsePlace"
                                ></modal-base-useplace>
                              </span>
                            </div>
                          </div>
                          <span class="w-100 text-center text-dark h12">
                            {{ getSUsePlaceName(newBaseUserPlace_NCode) }}
                          </span>
                          <filter-base-user-place 
                            v-if="isShowFilterBaseUsePlace"
                            v-bind:RandomNumberChild="RandomNumber" 
                            v-bind:FilterCode="newBaseUserPlace_NCode"
                            v-on:HideFilter="HideModalBaseUsePlace"
                          ></filter-base-user-place>
                        </div>
                      </td>
                      <!-- سطر جدید - قراردادها -->
                      <td style="vertical-align: text-top !important">
                        <div class="row shortText">
                          <div class="input-group px-1">
                            <input type="text" autocomplete="off" id="textBaseUsePlace" class="
                                form-control form-control-sm
                                rounded-0
                                text-center
                              " 
                              :class="{invalid: newBaseAgreement_NAgrID_Invlid,}" 
                              style="direction: ltr" 
                              v-model="newBaseAgreement_NAgrID" 
                              v-on:focus="$event.target.select(); HideFilterModal(); onlyNumberAndFilterBaseAgreement()" 
                              v-on:keyup.enter="ManageFocusText('BaseAgreement', true)" 
                              v-on:keypress="onlyNumberAndFilterBaseAgreement" 
                              :disabled="checkDisabledGharardad" 
                              title="فشردن + : نمایش لیست کامل"
                            />
                            <div class="input-group-prepend rounded-0">
                              <span class="
                                  input-group-text input-group-box-size
                                  bg-danger
                                  rounded-left
                                  white-text
                                ">
                                <a v-on:click="ShowModal('BaseAgreement', true)" v-if="!checkDisabledGharardad">
                                  <i class="fas fa-bars fa-sm" aria-hidden="true"></i>
                                </a>
                                <i v-else class="fas fa-bars fa-sm" aria-hidden="true"></i>

                                <modal-base-agreement v-if="isShowModalBaseAgreement"
                                  v-on:HideModal="HideModalBaseAgreement"></modal-base-agreement>
                              </span>
                            </div>
                          </div>
                          <span class="w-100 text-center text-dark h12">
                            {{ getSAgreementName(newBaseAgreement_NAgrID) }}
                          </span>
                          <filter-base-agreement-list 
                            v-if="isShowFilterBaseAgreement"
                            v-bind:RandomNumberChild="RandomNumber"
                            v-bind:FilterCode="newBaseAgreement_NAgrID"
                            v-on:HideFilter="HideModalBaseAgreement"
                          ></filter-base-agreement-list>
                        </div>
                      </td>
                      <!-- سطر جدید - بدهکار -->
                      <td style="vertical-align: text-top !important">
                        <div class="row px-1">
                          <input type="text" id="textNDebit" 
                            class="form-control form-control-sm text-center"
                            :class="{ invalid: newNDebit_Invalid }" 
                            style="direction: ltr"
                            v-on:focus="$event.target.select(); HideFilterModal();" 
                            v-on:keyup.enter="ChangeFocusText('NCredit')"
                            v-on:keyup="onlyNumber" 
                            v-model="newNDebit" 
                            :disabled="checkDisabledNDebit" 
                            title="فشردن . درج 000"
                          />
                        </div>
                      </td>
                      <!-- سطر جدید - بستانکار -->
                      <td style="vertical-align: text-top !important">
                        <div class="row px-1">
                          <input id="textNCredit" 
                            class="form-control form-control-sm text-center"
                            :class="{ invalid: newNCredit_Invalid }" 
                            style="direction: ltr"
                            v-on:focus="$event.target.select(); HideFilterModal();" 
                            v-on:keyup.enter="ChangeFocusText('SAccDesc')"
                            v-on:keyup="onlyNumber" 
                            v-model="newNCredit" 
                            :disabled="checkDisabledNCredit" 
                            title="فشردن . درج 000"
                          />
                        </div>
                      </td>
                    </tr>
                    <tr v-if="checkNewRow" class="bg-danger-light rowBrderBotton">
                      <!-- سطر جدید - شرح حساب -->
                      <td colspan="6">
                        <div class="row">
                          <div class="input-group px-1">
                            <input type="text" id="textSharheHesab" class="form-control form-control-sm rounded-0"
                              :class="{ invalid: newSAccDesc_Invalid }" 
                              v-on:focus="
                                $event.target.select();
                                HideFilterModal();
                                showFilterSAccDesc($event);" 
                              v-on:change="newSAccDesc_Invalid = false" v-on:keyup="checkKeySharheHesab"
                              v-on:keyup.enter="ChangeFocusText('NCode')" v-model="newSAccDesc" autocomplete="off" />
                            <div class="input-group-prepend rounded-0">
                              <span class="
                                  input-group-text input-group-box-size
                                  bg-danger
                                  rounded-left
                                  white-text
                                ">
                                <i class="fas fa-bars fa-sm" aria-hidden="true"></i>
                              </span>
                            </div>
                          </div>
                          <keep-alive>
                            <!-- ارسال شرح سند و شرح ردیف های سند به لیست کشویی -->
                            <filter-saccdesc v-if="isShowFilterSAccDesc" v-bind:FilterSDesc="newSAccDesc"
                              v-bind:SDocDesc="AccDocData.SDocDesc" v-bind:ListTbAccDocRecord="AccDocData.ListTbAccDocRecord
                                " v-bind:LocationShow="LocationShowFilterSAccDesc"
                              v-on:HideFilter="HideFilterSAccDesc"></filter-saccdesc>
                          </keep-alive>
                        </div>
                      </td>
                    </tr>

                    <!-- سایر سطرهای جدول -->
                    <template v-for="(item, index) in AccDocData.ListTbAccDocRecord">
                      <!-- مربوط به وضعیت نمایش سطر -->
                      <template v-if="item.checkEdit == false">
                        <tr :key="item.NIOId" class="rowBoxShadow rowCursorPointer"
                          :class="className(item.checkEdit, item.NIOId)" v-on:click="selectRowID = item.NIOId"
                          v-bind:id="(index == 0 ? 'FirstRowAccDoc' : item.NIOId)"
                        >
                          <!-- ردیف -->
                          <td class="tdGradient2" rowspan="2">
                            <div class="
                                d-flex
                                flex-column
                                justify-content-center
                                align-items-center
                              ">
                              <!-- سطر بالای منوی هر ردیف -->
                              <div style="
                                  display: flex;
                                  justify-content: center;
                                  align-items: center;
                                ">
                                <!-- چک باکس انتخاب چند سطری -->
                                <input v-if="showCheckBoxDeleteRow" type="checkbox" v-bind:value="item.NIOId"
                                  v-bind:id="item.NIOId" v-model="checkedRowSelect" />
                                <!-- لیبل شماره سطر -->
                                <label style="
                                    padding: 0 5px;
                                    margin: 0;
                                    margin-bottom: 5px;
                                  ">
                                  {{ item.NIOId }}
                                </label>
                                <!-- فلش نمایش انتخاب سطر -->
                                <!-- <i
                                  v-if="selectRowID == item.NIOId"
                                  class="
                                    fas
                                    fa-caret-left fa-lg
                                    pr-1
                                    text-primary
                                  "
                                ></i> -->
                              </div>
                              <!-- سطر پایین منوی هر ردیف -->
                              <div style="
                                  display: flex;
                                  justify-content: center;
                                  align-items: center;
                                ">
                                <a v-on:click="callCopyAndNewRow(item.NIOId)" title="کپی این سطر (Alt+i)"><i
                                    class="fas fa-copy fa-x2 m-1 text-info"></i></a>
                                <a v-on:click="callMoveAmount(item.NIOId)" title="جابجایی مبلغ (Alt+m)"><i class="
                                      fas
                                      fa-exchange-alt fa-x2
                                      m-1
                                      text-info
                                    "></i></a>
                                <a v-on:click="callEditRow(item.NIOId)" title="ویرایش (Alt+e)"><i
                                    class="fas fa-pen fa-x2 m-1 text-info"></i></a>
                                <a v-on:click="deleteRow()" title="حذف (Alt+d)"><i
                                    class="fas fa-trash-alt fa-x2 m-1 text-info"></i></a>
                              </div>
                            </div>
                          </td>
                          <!-- کد حساب -->
                          <td class="tdGradient shortText">
                            {{ item.NAccCode }}
                            <span v-bind:title="item.SAccCode" class="h12 mr-1">{{ item.SAccCode }}</span>
                          </td>
                          <!-- طرف حساب -->
                          <td class="tdGradient shortText">
                            {{ item.NPerID }}
                            <!-- <pre>{{ getTarafHesabName(item.NPerID) }}</pre> -->
                            <span v-bind:title="item.LName" class="h12 mr-1">{{ item.LName }}</span>
                          </td>
                          <!-- مرکز هزینه -->
                          <td class="tdGradient shortText">
                            {{ item.NUsePlace }}
                            <span v-bind:title="item.SUsePlace" class="h12 mr-1">{{ item.SUsePlace }}</span>
                          </td>
                          <!-- قراردادها -->
                          <td class="tdGradient shortText">
                            {{ item.NAgrID }}
                            <span v-bind:title="item.SAgreement" class="h12 mr-1">{{ item.SAgreement }}</span>
                          </td>
                          <!-- بدهکار -->
                          <td class="tdGradient2" rowspan="2" style="font-weight: 500 !important">
                            {{ item.NDebit | numFormat }}
                          </td>
                          <!-- بستانکار -->
                          <td class="tdGradient2" rowspan="2" style="font-weight: 500 !important">
                            {{ item.NCredit | numFormat }}
                          </td>
                        </tr>
                        <!-- شرح حساب -->
                        <tr :key="'SAccDesc' + item.NIOId" class="rowCursorPointer"
                          :class="className(item.checkEdit, item.NIOId)" v-on:click="selectRowID = item.NIOId"
                          v-bind:id="'SAccDesc' + item.NIOId">
                          <td colspan="4" class="text-truncate" style="
                              text-align: right !important;
                              padding-right: 5px !important;
                              padding-top: 1px !important;
                              padding-bottom: 1px !important;
                            ">
                            شرح : {{ item.SAccDesc }}
                          </td>
                        </tr>
                      </template>
                      <!-- پایان وضعیت نمایش سطر -->

                      <!-- مربوط به وضعیت ویرایش سطر -->
                      <template v-else>
                        <tr :key="item.NIOId" :class="className(item.checkEdit, item.NIOId)" class="rowBoxShadow"
                          v-on:click="selectRowID = item.NIOId" v-bind:id="item.NIOId">
                          <td rowspan="2" class="text-primary">
                            <div class="
                                d-flex
                                flex-column
                                justify-content-center
                                align-items-center
                              ">
                              <div>
                                <a v-if="invalidEditCheck(
                                  newNAccCode_NCode,
                                  newNPerID_NPerID
                                ).state
                                  " v-on:click="saveEditRow(item.NIOId)" title="ذخیره (Alt+s)"><i
                                    class="fas fa-save fa-lg m-1 text-primary"></i></a>
                                <a v-on:click="cancelEditRow(item.NIOId)" title="انصراف (Alt+c)"><i
                                    class="fas fa-ban fa-lg m-1 text-danger"></i></a>
                              </div>
                              <span>ویرایش</span>
                            </div>
                          </td>
                          <!-- ویرایش کد حساب -->
                          <td style="vertical-align: text-top !important">
                            <div class="row">
                              <div class="input-group px-1">
                                <input type="text" autocomplete="off" id="textHesabCode" class="
                                    form-control form-control-sm
                                    rounded-0
                                    text-center
                                  " :class="{
                                    invalid: newNAccCode_NCode_Invalid,
                                  }" style="direction: ltr" 
                                  v-model="newNAccCode_NCode" 
                                  v-on:focus="
                                    $event.target.select();
                                    HideFilterModal();
                                    onlyNumberAndFilterHesabCode();
                                  " 
                                  v-on:blur="getTbBaseAccDescDataName()" 
                                  v-on:keyup.enter="ManageFocusText('NCode', true)" 
                                  v-on:keypress="onlyNumberAndFilterHesabCode" 
                                  title="فشردن + : نمایش لیست کامل"
                                />
                                <div class="input-group-prepend rounded-0">
                                  <span class="
                                      input-group-text input-group-box-size
                                      bg-primary
                                      rounded-left
                                      white-text
                                    ">
                                    <a v-on:click="ShowModal('HesabCode', true)">
                                      <i class="fas fa-bars fa-sm" aria-hidden="true"></i>
                                    </a>
                                    <keep-alive>
                                      <modal-hesab-code v-if="isShowModalHesabCode"
                                        v-on:HideModal="HideModalHesabCode"></modal-hesab-code>
                                    </keep-alive>
                                  </span>
                                </div>
                                <br />
                              </div>
                              <span class="w-100 text-center text-dark h12 mt-1">
                                {{
                                  getHesabNameByNewOrEditRow(newNAccCode_NCode)
                                }}
                              </span>
                              <filter-hesab-code 
                                v-if="isShowFilterHesabCode" 
                                v-bind:RandomNumberChild="RandomNumber"
                                v-bind:HesabCode="newNAccCode_NCode"
                                v-on:HideFilterHesab="HideModalHesabCode"
                              ></filter-hesab-code>
                            </div>
                          </td>
                          <!-- ویرایش طرف حساب -->
                          <td style="vertical-align: text-top !important">
                            <div class="row">
                              <div class="input-group px-1">
                                <input 
                                  type="text" 
                                  autocomplete="off" 
                                  id="textTarafHesab" 
                                  class="
                                    form-control 
                                    form-control-sm
                                    rounded-0
                                    text-center
                                  " 
                                  :class="{ invalid: newNPerID_NPerID_Invalid }" 
                                  style="direction: ltr"
                                  v-model="newNPerID_NPerID" 
                                  v-on:focus="
                                    $event.target.select();
                                    HideFilterModal();
                                    onlyNumberAndFilterTarafHesab()
                                  " 
                                  v-on:keyup.enter="ManageFocusText('BaseUsePlace', true)" 
                                  v-on:keypress="onlyNumberAndFilterTarafHesab" 
                                  :disabled="checkDisabledTarafHesab" 
                                  title="فشردن + : نمایش لیست کامل"
                                />
                                <div class="input-group-prepend rounded-0">
                                  <span class="
                                      input-group-text input-group-box-size
                                      bg-primary
                                      rounded-left
                                      white-text
                                    ">
                                    <a v-on:click="ShowModal('TarafHesab', true)" v-if="!checkDisabledTarafHesab">
                                      <i class="fas fa-bars fa-sm" aria-hidden="true"></i>
                                    </a>
                                    <i v-else class="fas fa-bars fa-sm" aria-hidden="true"></i>

                                    <!-- تگ کیپ قرار است مانع ایجاد مجدد کامپاننت شود
                                    این کار سرعت لود کامپاننت را در فراخوانی های بعدی افزایش می دهد
                                    البته الان به ظاهر کار نمی کند که علتش باید بررسی شود -->
                                    <keep-alive>
                                      <modal-taraf-hesab v-if="isShowModalTarafHesab"
                                        v-bind:NAccType="newNAccCode_NAccType"
                                        v-on:HideModal="HideModalTarafHesab"></modal-taraf-hesab>
                                    </keep-alive>
                                  </span>
                                </div>
                              </div>
                              <span class="w-100 text-center text-dark h12 mt-1">
                                {{ getTarafHesabName(newNPerID_NPerID) }}
                              </span>
                              <filter-taraf-hesab 
                                v-if="isShowFilterTarafHesab" 
                                v-bind:RandomNumberChild="RandomNumber" 
                                v-bind:TarafCode="newNPerID_NPerID"
                                v-bind:NAccType="newNAccCode_NAccType"
                                v-on:HideFilterTarafHesab="HideModalTarafHesab"></filter-taraf-hesab>
                            </div>
                          </td>
                          <!-- ویرایش مرکز هزینه -->
                          <td style="vertical-align: text-top !important">
                            <div class="row">
                              <div class="input-group px-1">
                                <input type="text" autocomplete="off" id="textBaseUsePlace" class="
                                    form-control form-control-sm
                                    rounded-0
                                    text-center
                                  " :class="{
                                    invalid: newBaseUserPlace_NCode_Invalid,
                                  }" style="direction: ltr" v-model="newBaseUserPlace_NCode" v-on:focus="
  $event.target.select();
HideFilterModal();
" v-on:blur="HideFilterModal()" v-on:keyup.enter="
  ManageFocusText('BaseAgreement', true)
  " v-on:keypress="onlyNumberAndFilterBaseUsePlace
    " :disabled="checkDisabledMarkazHazine" />
                                <div class="input-group-prepend rounded-0">
                                  <span class="
                                      input-group-text input-group-box-size
                                      bg-primary
                                      rounded-left
                                      white-text
                                    ">
                                    <a v-on:click="
                                      ShowModal('BaseUsePlace', true)
                                      " v-if="!checkDisabledMarkazHazine">
                                      <i class="fas fa-bars fa-sm" aria-hidden="true"></i>
                                    </a>
                                    <i v-else class="fas fa-bars fa-sm" aria-hidden="true"></i>

                                    <modal-base-useplace v-if="isShowModalBaseUsePlace"
                                      v-on:HideModal="HideModalBaseUsePlace"></modal-base-useplace>
                                  </span>
                                </div>
                              </div>
                              <span class="w-100 text-center text-dark h12 mt-1">
                                {{
                                  getSUsePlaceName(newBaseUserPlace_NCode)
                                }}
                              </span>
                              <filter-base-user-place v-if="isShowFilterBaseUsePlace"
                                v-bind:FilterCode="newBaseUserPlace_NCode"
                                v-on:HideFilter="HideModalBaseUsePlace"></filter-base-user-place>
                            </div>
                          </td>
                          <!-- ویرایش قراردادها -->
                          <td style="vertical-align: text-top !important">
                            <div class="row">
                              <div class="input-group px-1">
                                <input type="text" autocomplete="off" id="textBaseUsePlace" class="
                                    form-control form-control-sm
                                    rounded-0
                                    text-center
                                  " :class="{
                                    invalid: newBaseAgreement_NAgrID_Invlid,
                                  }" style="direction: ltr" v-model="newBaseAgreement_NAgrID" v-on:focus="
  $event.target.select();
HideFilterModal();
" v-on:keyup.enter="
  ManageFocusText('BaseAgreement', true)
  " v-on:keypress="onlyNumberAndFilterBaseAgreement
    " :disabled="checkDisabledGharardad" />
                                <div class="input-group-prepend rounded-0">
                                  <span class="
                                      input-group-text input-group-box-size
                                      bg-primary
                                      rounded-left
                                      white-text
                                    ">
                                    <a v-on:click="
                                      ShowModal('BaseAgreement', true)
                                      " v-if="!checkDisabledGharardad">
                                      <i class="fas fa-bars fa-sm" aria-hidden="true"></i>
                                    </a>
                                    <i v-else class="fas fa-bars fa-sm" aria-hidden="true"></i>

                                    <modal-base-agreement v-if="isShowModalBaseAgreement"
                                      v-on:HideModal="HideModalBaseAgreement"></modal-base-agreement>
                                  </span>
                                </div>
                              </div>
                              <span class="w-100 text-center text-dark h12 mt-1">
                                {{
                                  getSAgreementName(newBaseAgreement_NAgrID)
                                }}
                              </span>
                              <filter-base-agreement-list v-if="isShowFilterBaseAgreement"
                                v-bind:FilterCode="newBaseAgreement_NAgrID"
                                v-on:HideFilter="HideModalBaseAgreement"></filter-base-agreement-list>
                            </div>
                          </td>
                          <!-- ویرایش بدهکار -->
                          <td style="vertical-align: text-top !important">
                            <div class="row px-1">
                              <input type="text" id="textNDebit" class="form-control form-control-sm text-center"
                                :class="{ invalid: newNDebit_Invalid }" style="direction: ltr" v-on:focus="
                                  $event.target.select();
                                HideFilterModal();
                                " v-on:keyup.enter="ChangeFocusText('NCredit')" v-on:keyup="onlyNumber"
                                v-model="newNDebit" :disabled="checkDisabledNDebit" />
                            </div>
                          </td>
                          <!-- ویرایش بستانکار -->
                          <td style="vertical-align: text-top !important">
                            <div class="row px-1">
                              <input type="text" id="textNCredit" class="form-control form-control-sm text-center"
                                :class="{ invalid: newNCredit_Invalid }" style="direction: ltr" v-on:focus="
                                  $event.target.select();
                                HideFilterModal();
                                " v-on:keyup.enter="ChangeFocusText('SAccDesc')" v-on:keyup="onlyNumber"
                                v-model="newNCredit" :disabled="checkDisabledNCredit" />
                            </div>
                          </td>
                        </tr>
                        <!-- ویرایش شرح حساب -->
                        <tr :key="'SAccDesc' + item.NIOId" :class="className(item.checkEdit, item.NIOId)"
                          v-on:click="selectRowID = item.NIOId" v-bind:id="'SAccDesc' + item.NIOId">
                          <td colspan="6" class="text-truncate" style="
                              text-align: right !important;
                              padding-right: 5px !important;
                            ">
                            <div class="row">
                              <div class="input-group px-1">
                                <input type="text" id="textSharheHesab" class="form-control form-control-sm"
                                  :class="{ invalid: newSAccDesc_Invalid }" v-on:focus="
                                    $event.target.select();
                                  HideFilterModal();
                                  showFilterSAccDesc($event);
                                  " v-on:change="newSAccDesc_Invalid = false" v-on:keyup="checkKeySharheHesab"
                                  v-on:keyup.enter="ChangeFocusText('NCode')" v-model="newSAccDesc" autocomplete="off" />
                                <div class="input-group-prepend rounded-0">
                                  <span class="
                                      input-group-text input-group-box-size
                                      bg-danger
                                      rounded-left
                                      white-text
                                    ">
                                    <i class="fas fa-bars fa-sm" aria-hidden="true"></i>
                                  </span>
                                </div>
                              </div>
                              <keep-alive>
                                <!-- ارسال شرح سند و شرح ردیف های سند به لیست کشویی -->
                                <filter-saccdesc v-if="isShowFilterSAccDesc" v-bind:FilterSDesc="newSAccDesc"
                                  v-bind:SDocDesc="AccDocData.SDocDesc" v-bind:ListTbAccDocRecord="AccDocData.ListTbAccDocRecord
                                    " v-bind:LocationShow="LocationShowFilterSAccDesc
    " v-on:HideFilter="HideFilterSAccDesc"></filter-saccdesc>
                              </keep-alive>
                            </div>
                          </td>
                        </tr>
                      </template>
                      <!-- پایان وضعیت ویرایش سطر -->
                    </template>

                    <!-- سطر نمایش جمع کل سند -->
                    <tr class="rowBoxShadow">
                      <td class="border-0" style="text-align: right !important;">
                        <!-- انتقال به سطر ابتدایی -->
                        <a id="LastRowAccDoc" v-if="AccDocData.ListTbAccDocRecord.length > 5" v-on:click="scrollTable('FirstRowAccDoc')" title="مشاهده سطر ابتدایی">
                          <i class="far fa-arrow-alt-circle-up fa-1x-half text-secondary"></i>
                        </a>
                      </td>
                      <td class="border-0"></td>
                      <td class="border-0"></td>
                      <td colspan="2" :style="styleSumAmountRow()" :class="{
                        'text-danger': !SumAmountRow.AlignmentStatus,
                      }">
                        <i title="سند تراز نمی باشد !" v-if="!SumAmountRow.AlignmentStatus"
                          class="fas fa-exclamation-triangle text-danger ml-1" style="cursor: pointer"></i>
                        وضعیت سند : {{ SumAmountRow.DocStatus }}
                      </td>
                      <td :style="styleSumAmountRow()" :class="{
                        'text-danger': !SumAmountRow.AlignmentStatus,
                      }" style="
                          font-weight: 500 !important;
                          font-size: 13px !important;
                        ">
                        {{ SumAmountRow.SumNDebit | numFormat }}
                      </td>
                      <td :style="styleSumAmountRow()" :class="{
                        'text-danger': !SumAmountRow.AlignmentStatus,
                      }" style="
                          font-weight: 500 !important;
                          font-size: 13px !important;
                        ">
                        {{ SumAmountRow.SumNCredit | numFormat }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- میله ابزار پایین سند -->
            <div class="row p-2">
              <!-- دکمه های پایین سند -->
              <div class="col-6">
                <div class="input-group px-1">
                  <input v-bind:id="'textSanadSearch-' + tabData.TabID" placeholder="جستجو پیشرفته در سند (F3/Enter)"
                    type="text" class="form-control form-control-sm rounded-0" v-on:focus="$event.target.select()"
                    v-on:keyup.enter="searchData($event.target.value)" v-on:keyup.f3="SelectHesab()" />
                  <div class="input-group-prepend rounded-0">
                    <span class="
                        input-group-text input-group-box-size
                        bg-secondary
                        rounded-left
                        white-text
                      ">
                      <a v-on:click="searchData('Search')">
                        <i class="fas fa-search"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 p-0">
                <!-- <div
                  class="d-inline-flex justify-content-end align-items-center bg-secondary rounded"
                >
                  <a
                    href="AdminPanel.html"
                    class="text-decoration-none px-4 py-1 text-white m-0"
                  >
                    <strong>چاپ</strong>
                  </a>
                  <a
                    href="AdminPanel.html"
                    style="background-color: #623879"
                    class="text-decoration-none p-2 text-white m-0 rounded-left"
                  >
                    <i class="fas fa-print fa-2x"></i>
                  </a>
                </div> -->

                <div class="
                    d-inline-flex
                    justify-content-end
                    align-items-center
                    bg-secondary
                    rounded
                  ">
                  <a v-on:click="deleteDataFromServer()" class="text-decoration-none px-4 py-1 text-white m-0">
                    <strong>حذف</strong>
                  </a>
                  <a v-on:click="deleteDataFromServer()" style="background-color: #623879"
                    class="text-decoration-none p-2 text-white m-0 rounded-left">
                    <i class="fas fa-trash fa-2x"></i>
                  </a>
                </div>

                <div style="background-color: #78909c" class="
                    d-inline-flex
                    justify-content-end
                    align-items-center
                    rounded
                  " :class="{ 'bg-secondary': SumAmountRow.AlignmentStatus }">
                  <a v-on:click="SaveTbDocInfo(tabData.TabID)" class="text-decoration-none px-4 py-1 text-white m-0">
                    <strong>ذخیره ( F4 )</strong>
                  </a>
                  <a v-on:click="SaveTbDocInfo(tabData.TabID)" style="background-color: #623879"
                    class="text-decoration-none p-2 text-white m-0 rounded-left"
                    :class="{ 'bg-dark': !SumAmountRow.AlignmentStatus }">
                    <i class="fas fa-save fa-2x"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- بدنه اطلاعات تکمیلی -->
          <div class="tab-pane fade w-100" id="tabInfo">
            <div class="row p-5">
              <h6>بخش اطلاعات تکمیلی</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {
//   numeric, // فقط عددی می پذیرد
//   integer, // فقط عدد صحیح می پذیرد
//   required, // نیاز به اطلاعات غیر خالی دارد
//   minValue, // حداقل عددی
// } from "vuelidate/lib/validators";
//import VueNumeric from "vue-numeric";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import ModalHesabCode from "./Components/ModalHesabCode.vue";
import ModalTarafHesab from "./Components/ModalTarafHesab.vue";
import ModalBaseUsePlace from "./Components/ModalBaseUsePlaceList.vue";
import ModalBaseAgreement from "./Components/ModalBaseAgreementList.vue";
import FilterHesabCode from "./Components/FilterHesabCode.vue";
import FilterTarafHesab from "./Components/FilterTarafHesab.vue";
import FilterBaseUsePlace from "./Components/FilterBaseUsePlace.vue";
import FilterBaseAgreementList from "./Components/FilterBaseAgreementList.vue";
import FilterSDocDesc from "./Components/FilterSDocDesc.vue";
import FilterSAccDesc from "./Components/FilterSAccDesc.vue";

import { BusEvent } from "../../../../main.js";

export default {
  components: {
    //"vue-numeric": VueNumeric,
    // کامپاننت تقویم شمسی
    datePicker: VuePersianDatetimePicker,
    // کامپاننت مودال کد حساب
    "modal-hesab-code": ModalHesabCode,
    // کامپاننت مودال طرف حساب
    "modal-taraf-hesab": ModalTarafHesab,
    // کامپاننت مودال مرکز هزینه
    "modal-base-useplace": ModalBaseUsePlace,
    // کامپاننت مودال قرادادها
    "modal-base-agreement": ModalBaseAgreement,
    // کامپاننت لیست کشویی کد حساب
    "filter-hesab-code": FilterHesabCode,
    // کامپاننت لیست کشویی طرف حساب
    "filter-taraf-hesab": FilterTarafHesab,
    // کامپاننت لیست کشویی مرکز هزینه
    "filter-base-user-place": FilterBaseUsePlace,
    // کامپاننت لیست کشویی قرادادها
    "filter-base-agreement-list": FilterBaseAgreementList,
    // کامپاننت لیست کشویی شرح سند
    "filter-sdocdesc": FilterSDocDesc,
    // کامپاننت لیست کشویی شرح حساب - شرح ردیف
    "filter-saccdesc": FilterSAccDesc,
  },
  computed: {
    getTbBaseDocTypeData() {
      // دریافت لیست انواع سند
      return this.$store.getters.getTbBaseDocTypeData;
    },
    getTbBaseOrgData() {
      // دریافت لیست سازمان ها
      return this.$store.getters.getTbBaseOrgData;
    },
  },
  props: { tabData: {}, tabActive: { type: Number } },
  data() {
    return {
      // فیلدهای کنترلی درج سطر جدید و ویرایش
      ArrowKeyEnable: true, // غیرفعال کردن کلید میانبرهای جهت نما
      HotKeyEnable: true, // غیرفعال کردن کلید میانبرها به علت نمایش مودال
      checkNewRow: false, // وضعیت درج سطر جدید
      editNIOId: 0, // کد سطر در حال ویرایش
      checkDisabledTarafHesab: true, // نیاز به ثبت طرف حساب نمی باشد
      checkDisabledNDebit: true, // نیازی به ثبت بدهکار نمی باشد
      checkDisabledNCredit: true, // نیازی به ثبت بستانکار نمی باشد
      checkDisabledMarkazHazine: true, // نیاز به ثبت مرکز هزینه نمی باشد
      checkDisabledGharardad: true, // نیاز به ثبت قرارداد نمی باشد

      // نمایش چک باکس حذف ردیف ها
      showCheckBoxDeleteRow: false,

      // تاریخ درج شده با سال مالی مطابقت ندارد
      AlarmNotSetDate: false,

      // فیلد اصلی جهت مرتب سازی رکوردهای سند
      // sortField: { name: "NIOId", type: "desc" },

      // فیلد نگهداری نام آخرین فیلد مرتب سازی شده
      lastSortFieldName: "",

      // فیلد نگهداری رکوردهای انتخاب شده
      checkedRowSelect: [],

      // متغییر موقت نگهدارنده تاریخ سند
      SDocDateTemp: "",

      // اطلاعات سند
      AccDocData: {
        RowID: 0,
        NId: 0,
        NYear: 0,
        NDocNu: 0,
        SDocDate: "",
        SDocDesc: "",
        NDocType: 0,
        NUserCode: 0,
        NOrgCode: 0,
        ListTbAccDocRecord: [
          {
            Code: 0,
            NIOId: 0,
            NAccCode: 0,
            SAccCode: "",
            NPerID: 0,
            LName: "",
            SAccDesc: "",
            NDebit: 0,
            NCredit: 0,
            checkEdit: false,
            NUsePlace: 0,
            SUsePlace: "",
            NAgrID: 0,
            SAgreement: "",
            NUserCode: 0,
          },
        ],
        CheckChangeData: false,
      },

      // مربوط به درج سطر جدید

      // اطلاعات کد حساب
      newNAccCode_NCode: 0,
      newNAccCode_SDesc: "",
      newNAccCode_NAccType: 0,

      // اطلاعات طرف حساب
      newNPerID_NPerID: 0,
      newNPerID_NPerName: "",
      newNPerID_NPerLastName: "",
      newNPerID_NPerType: 0,

      // اطلاعات مرکز هزینه
      newBaseUserPlace_NCode: 0,
      newBaseUserPlace_SDesc: "",
      newBaseUserPlace_SDate: "",

      // اطلاعات قراردادها
      newBaseAgreement_NAgrID: 0,

      // newNPerID: 0,
      newSAccDesc: "",
      newNDebit: 0, // بدهکار
      newNCredit: 0, // بستانکار
      NAccType: 0, // نوع کد حساب
      NPerID: 0, // نوع NPerID از جدول حساب ها

      newNAccCode_NCode_Invalid: false,
      newNPerID_NPerID_Invalid: false,
      newBaseUserPlace_NCode_Invalid: false,
      newBaseAgreement_NAgrID_Invlid: false,
      newNDebit_Invalid: false,
      newNCredit_Invalid: false,
      newSAccDesc_Invalid: false,

      // عدد تصادفی جهت تحریک کامپاننت ها
      RandomNumber: 0,
      // کنترل وضعیت نمایش لیست کشویی کد حساب
      isShowFilterHesabCode: false,
      // کنترل وضعیت نمایش لیست کشویی طرف حساب
      isShowFilterTarafHesab: false,
      // کنترل وضعیت نمایش لیست کشویی مرکز هزینه
      isShowFilterBaseUsePlace: false,
      // کنترل وضعیت نمایش لیست کشویی قراردادها
      isShowFilterBaseAgreement: false,
      // کنترل وضعیت نمایش لیست کشویی شرح سند
      isShowFilterSDocDesc: false,
      LocationShowFilterSDocDesc: {
        left: 1,
        top: 1,
        width: 100,
        height: 100,
      },
      // کنترل وضعیت نمایش لیست کشویی شرح حساب - شرح ردیف
      isShowFilterSAccDesc: false,
      LocationShowFilterSAccDesc: {
        left: 1,
        top: 1,
        width: 100,
        height: 100,
      },

      // کنترل وضعیت نمایش مودال حساب و طرف حساب
      isShowModalHesabCode: false,
      isShowModalTarafHesab: false,
      isShowModalBaseUsePlace: false,
      isShowModalBaseAgreement: false,

      // سطر در حال انتخاب
      selectRowID: 1,
      // موارد جستجو شده قبلی
      NIOIdSearch: [],
      // نگهدارنده وضعیت حساب سند
      SumAmountRow: {
        AlignmentStatus: true,
        SumNDebit: 0, // جمع بدهکار
        SumNCredit: 0, // جمع بستانکار
        DocStatus: "تراز",
      },
      // تاخیر در تایمر
      setTimeoutDelay: 200,
      // آیدی که در ذخیره و بازیابی اطلاعات محلی استفاده می شود
      tabIDInChild: 0,
      // اگر سند جدید است و تغییری در سطرها دارد
      // کد سند و شناسه سند غیرفعال گردد
      checkDisabledDocID: false,
    };
  },
  mounted() {
    // بازیابی اطلاعات سند در لحظه ایجاد تب
    this.getAccDocData();
  },
  methods: {
    // جابجایی به سطر جمع یا سربرگ
    scrollTable(objectID) {
        $("#" + objectID).scrollintoview({duration: 500,});
    },
    // بررسی وجود شرح حساب برای کد حساب درج شده
    async getTbBaseAccDescDataName() {
      if (this.newSAccDesc === "") {
        // بررسی کد حساب در لیست شرح حساب ها
        this.newSAccDesc = await this.$store.getters.getTbBaseAccDescDataName(
          this.newNAccCode_NCode
        );
      }
    },
    // نمایش کامپاننت شرح سند
    showFilterSDocDesc(event) {
      // دریافت موقعیت والد و ارسال به کامپاننت فرزند
      this.LocationShowFilterSDocDesc.left = event.target.clientLeft;
      this.LocationShowFilterSDocDesc.top = event.target.clientTop;
      this.LocationShowFilterSDocDesc.width = event.target.clientWidth;
      this.LocationShowFilterSDocDesc.height = event.target.clientHeight;
      // غیرفعال سازی کلید میانبرهای جهت نما
      this.ArrowKeyEnable = false;
      // نمایش کامپاننت شرح سند
      this.isShowFilterSDocDesc = true;
    },

    // نمایش کامپاننت شرح حساب - شرح ردیف
    showFilterSAccDesc(event) {
      // دریافت موقعیت والد و ارسال به کامپاننت فرزند
      this.LocationShowFilterSAccDesc.left = event.target.clientLeft;
      this.LocationShowFilterSAccDesc.top = event.target.clientTop;
      this.LocationShowFilterSAccDesc.width = event.target.clientWidth;
      this.LocationShowFilterSAccDesc.height = event.target.clientHeight;
      // غیرفعال سازی کلید میانبرهای جهت نما
      this.ArrowKeyEnable = false;
      // نمایش کامپاننت شرح سند
      this.isShowFilterSAccDesc = true;
    },

    // بررسی صحت فرمت تاریخ درج شده
    checkDateFormat() {
      if (this.SDocDateTemp != "") {
        var test = this.SDocDateTemp.split("/");
        if (
          test.length == 3 &&
          test[0].length == 4 &&
          test[1] > 0 &&
          test[1] <= 12 &&
          test[2] > 0 &&
          test[2] <= 31
        ) {
          // فعالسازی کلیدهای جهت نمای حرکت بین رکوردهای سند
          this.ArrowKeyEnable = true;
        } else {
          this.$store.dispatch("notify", {
            notText: "فرمت تاریخ صحیح نیست !",
            timeOut: 2500,
          });
          $("#the-mask-input-" + this.tabData.TabID).focus();
          $("#the-mask-input-" + this.tabData.TabID).select();
        }
      }
    },

    getDateShamsi(plus) {
      // دریافت تاریخ جاری و شکستن آن
      var inputDate = this.AccDocData.SDocDate.split("/");
      // تعریف متغییر تاریخ از کتابخانه مدیریت تاریخ شمسی
      var shamsi = require("shamsi-date-converter");
      let today;
      if (plus) {
        // محاسبه یک روز بیشتر
        today = new Date(
          new Date(
            shamsi.jalaliToGregorian(
              parseInt(inputDate[0]),
              parseInt(inputDate[1]),
              parseInt(inputDate[2])
            )
          ).getTime() +
          24 * 60 * 60 * 1000
        ).toLocaleDateString("fa-IR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          formatMatcher: "basic",
        });
      } else {
        // محاسبه یک روز کمتر
        today = new Date(
          new Date(
            shamsi.jalaliToGregorian(
              parseInt(inputDate[0]),
              parseInt(inputDate[1]),
              parseInt(inputDate[2])
            )
          ).getTime() -
          24 * 60 * 60 * 1000
        ).toLocaleDateString("fa-IR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          formatMatcher: "basic",
        });
      }
      // تبدیل اعداد فارسی به لاتین
      today = today.replace(/([۰-۹])/g, (token) =>
        String.fromCharCode(token.charCodeAt(0) - 1728)
      );
      // ذخیره تغییرات در متغییر موقت تاریخ
      this.SDocDateTemp = today;
      //this.AccDocData.SDocDate = today;
      // ثبت وجود تغییرات در سند
      this.setChangeAccDocData();
      // انتخاب محتویات تاریخ
      setTimeout(() => {
        $("#the-mask-input-" + this.tabData.TabID).select();
      }, 50);
    },
    // نمایش آلارم عدم تطابق تاریخ با سال مالی
    showAlarmNotSetDate(message) {
      this.AlarmNotSetDate = true;
      this.$store.dispatch("notify", {
        notText: message,
        timeOut: 2500,
      });
    },
    // نمایش تقویم هجری شمسی
    showDatePicker(tabid) {
      // فراخوانی رویداد کلیک دکمه تقویم
      document.getElementById("my-custom-input-" + tabid).click();
    },
    // بازیابی اطلاعات سند
    getAccDocData() {
      if (this.tabData.LocalData == true) {
        // برای سند اطلاعات لوکال مشاهده شده است
        this.AccDocData = this.tabData.TabAccDocData;
        // تغییر وضعیت سند به حالت نیاز به ذخیره سازی
        // this.AccDocData.CheckChangeData = true;
        // ثبت وجود تغییرات در سند
        this.setChangeAccDocData(false);
        // از این فیلد جهت مدیریت ذخیره سازی محلی استفاده می شود
        this.tabIDInChild = this.AccDocData.NDocNu;
        // محاسبه جمع ستون های بدهکار و بستانکار
        this.calcSumAmountRow();
        // آیا برای سند سطری ثبت شده است
        if (this.AccDocData.ListTbAccDocRecord.length > 0) {
          // انتخاب اولین سطر سند
          this.selectRowID = this.AccDocData.ListTbAccDocRecord[0].NIOId;
        }
        // مقداردهی به متغییر موقت تاریخ
        this.SDocDateTemp = this.AccDocData.SDocDate;
      } else {
        // سند فاقد اطلاعات لوکال است
        if (this.tabData.NId > 0) {
          // اگر کد سند مشخص است اطلاعات از سرور دریافت گردد
          this.SearchNIdNDocNuInServer(this.tabData.NId, this.tabData.NDocNu);
        } else {
          // کد سند خالی است لذا مقدار دهی با سند خام
          this.AccDocData = {
            RowID: 1,
            NId: this.tabData.NId,
            NYear: this.$store.getters.getPersianDateValue.PersianYear,
            NDocNu: this.tabData.NDocNu,
            SDocDate: this.$store.getters.getPersianDateValue.PersianDate,
            SDocDesc: "",
            NDocType: this.$store.getters.getNDocTypeCodeForNewDoc,
            NOrgCode: this.$store.getters.getNOrgCodeCodeForNewDoc,
            NUserCode: this.$store.getters.getUserData.NUserCode,
            ListTbAccDocRecord: [],
            CheckChangeData: false,
            BStatus: false,
          };
          // مقداردهی به متغییر موقت تاریخ
          this.SDocDateTemp =
            this.$store.getters.getPersianDateValue.PersianDate;
          // از این فیلد جهت مدیریت ذخیره سازی محلی استفاده می شود
          this.tabIDInChild = this.AccDocData.NDocNu;
        }
      }
      setTimeout(() => {
        $("#the-mask-input-" + this.tabData.TabID).focus();
        $("#the-mask-input-" + this.tabData.TabID).select();
      }, 200);
    },

    // دریافت اطلاعات سند از سرور
    async SearchNIdNDocNuInServer(nId, nDocNu) {
      // نمایش لطفا صبر نمایید
      this.$store.dispatch("pleaseWait", {
        notText: "بازیابی اطلاعات سند از سرور",
      });

      let userData = await this.$store.getters.getUserData;
      // let NUserCode = userData.NUserCode;
      let token = userData.token;
      let yearActive = await this.$store.getters.getYearActive;

      // دریافت اطلاعات سند با استفاده از کد سند از سرور
      var docData = await this.$store.dispatch(
        "GetTbDocInfoByNIdNDocNuFromServer",
        {
          NId: nId,
          NDocNu: nDocNu,
          NYear: yearActive,
          token: token,
        }
      );

      // ذخیره مقدار بازگشتی از سرور در متغییر محلی
      this.AccDocData = docData;
      this.tabIDInChild = this.AccDocData.NDocNu;
      // آیا برای سند سطری درج شده است؟
      if (this.AccDocData.ListTbAccDocRecord.length > 0) {
        // مرتب سازی مقادیر سطرهای سند
        // this.sortDocRow("NIOId", "desc");
        // ثبت مقادیر نام حساب و نام طرف حساب در متغییر محلی
        // این مقادیر در جستجو کاربرد دارند
        // this.AccDocData.ListTbAccDocRecord.forEach((element) => {
        //   element.SAccCode = this.getHesabName(element.NAccCode);
        //   element.LName = this.getTarafHesabName(element.NPerID);
        //   element.SUsePlace = this.getSUsePlaceName(
        //     element.NUsePlace
        //   );
        //   element.SAgreement = this.getSAgreementName(element.NAgrID);
        // });
        // انتخاب اولین سطر سند
        this.selectRowID = this.AccDocData.ListTbAccDocRecord[0].NIOId;
      } else {
        this.selectRowID = 1;
      }
      // محاسبه جمع ستون های بدهکار و بستانکار
      this.calcSumAmountRow();
      // تغییر شماره و شناسه سند در تب جاری
      this.tabData.NId = this.AccDocData.NId;
      this.tabData.NDocNu = this.AccDocData.NDocNu;
      // وجود تغییرات به مخزن اصلی اعمال گردد
      this.setChangeDataInTab(this.tabData.TabID, false);

      // بررسی اینکه آیا کد نوع سند ، کد سازمان و تاریخ خالی نباشد
      // آیا مقدار کد نوع سند خالی است ؟
      if (this.AccDocData.NDocType == 0) {
        // مقدار دهی کد نوع سند با اولین نوع مجاز
        this.AccDocData.NDocType = this.$store.getters.getNDocTypeCodeForNewDoc;
      }
      // آیا مقدار کد سازمان خالی است ؟
      if (this.AccDocData.NOrgCode == 0) {
        // مقدار دهی کد سازمان با اولین سازمان مجاز
        this.AccDocData.NOrgCode = this.$store.getters.getNOrgCodeCodeForNewDoc;
      }
      // آیا مقدار تاریخ سند خالی است ؟
      if (this.AccDocData.SDocDate === "") {
        // تعریف متغییر تاریخ از کتابخانه مدیریت تاریخ شمسی
        var shamsi = require("shamsi-date-converter");
        // دریافت تاریخ جاری از سیستم عامل لوکال
        const date = new Date();
        // محاسبه تاریخ شمسی از تاریخ جاری
        var jalaliDate = shamsi.gregorianToJalali(date);
        // آیا تاریخ از مقدار دریافتی سرور مقدار دهی شود ؟
        // یا از مقدار محسابه شده لوکال ؟
        // مقدار دهی زمان جاری دریافتی از سرور به تاریخ و سال سند
        this.AccDocData.SDocDate =
          this.$store.getters.getPersianDateValue.PersianDate;
        this.AccDocData.NYear =
          this.$store.getters.getPersianDateValue.PersianYear;
      }
      // مقداردهی به متغییر موقت تاریخ
      this.SDocDateTemp = this.AccDocData.SDocDate;

      // لغو نمایش لطفا صبر نمایید
      this.$store.dispatch("pleaseWait", {
        stop: true,
      });
    },

    // استایل کادر جمع ردیف های سند
    styleSumAmountRow() {
      if (this.SumAmountRow.AlignmentStatus == true) {
        // return "background-color: #B2FF59; height: 40px;";
        return "background-color: #B2FF59; background: linear-gradient(rgb(163 234 80), rgb(178 255 89)); border: 1px solid #a0cc6e; height: 32px;";
      } else {
        // return "background-color: #EEFF41; height: 40px;";
        return "background-color: #EEFF41; background: linear-gradient(rgb(215 230 63), rgb(238 255 65)); border: 1px solid rgb(196 214 5); height: 32px;";
      }
    },

    // محاسبه جمع ستون های بدهکار و بستانکار
    calcSumAmountRow() {
      if (this.AccDocData.ListTbAccDocRecord.length > 0) {
        let sumNDebit = 0;
        let sumNCredit = 0;
        this.AccDocData.ListTbAccDocRecord.forEach((element) => {
          sumNDebit += parseInt(element.NDebit);
          sumNCredit += parseInt(element.NCredit);
        });
        this.SumAmountRow = {
          AlignmentStatus: sumNDebit == sumNCredit ? true : false,
          SumNDebit: sumNDebit,
          SumNCredit: sumNCredit,
          DocStatus:
            sumNDebit == sumNCredit
              ? "تراز"
              : sumNDebit > sumNCredit
                ? "بدهکار (مبلغ : " +
                Intl.NumberFormat().format(sumNDebit - sumNCredit) +
                ")"
                : "بستانکار (مبلغ : " +
                Intl.NumberFormat().format(sumNCredit - sumNDebit) +
                ")",
        };
      } else {
        this.SumAmountRow = {
          AlignmentStatus: true,
          SumNDebit: 0,
          SumNCredit: 0,
          DocStatus: "تراز",
        };
      }
    },

    // جستجو در لیست حساب ها
    searchData(searchValue) {
      if (searchValue === "Search") {
        searchValue =
          $("#textSanadSearch-" + this.tabData.TabID).val() != ""
            ? $("#textSanadSearch-" + this.tabData.TabID).val()
            : "";
      }
      if (searchValue != "") {
        let index = this.AccDocData.ListTbAccDocRecord.findIndex(
          (itme) =>
            (itme.NAccCode.toString().startsWith(searchValue) ||
              itme.SAccCode.toString().includes(searchValue) ||
              itme.NPerID.toString().startsWith(searchValue) ||
              itme.LName.toString().includes(searchValue) ||
              itme.SAccDesc.toString().includes(searchValue) ||
              itme.NDebit.toString().startsWith(searchValue) ||
              itme.NCredit.toString().startsWith(searchValue) ||
              itme.NUsePlace.toString().startsWith(searchValue) ||
              itme.SUsePlace.toString().includes(searchValue) ||
              itme.NAgrID.toString().startsWith(searchValue) ||
              itme.SAgreement.toString().includes(searchValue)) &&
            this.NIOIdSearch.indexOf(itme.NIOId) == -1
        );
        if (index != -1) {
          let NIOId = this.AccDocData.ListTbAccDocRecord[index].NIOId;
          $("#" + NIOId).scrollintoview({
            duration: 500,
            //complete: this.$store.dispatch("notify", { notText: "تست نمایش پیام !!", timeOut: 2500, });
          });
          this.selectRowID = this.AccDocData.ListTbAccDocRecord[index].NIOId;

          this.NIOIdSearch.push(NIOId);
        } else {
          // نمایش پیام مورد جدید یافت نشد ، لغو شد 1400/09/15
          // this.$store.dispatch("notify", {
          //   notText: "برای مقدار ( " + searchValue + " ) موردی پیدا نشد !",
          //   timeOut: 2500,
          // });
          this.NIOIdSearch = [];
          // فراخوانی مجدد تابع باعث ایجاد لوپ می شود
          // this.searchData(searchValue);
        }
      } else {
        this.$store.dispatch("notify", {
          notText: "مقداری برای جستجو درج نشده است !",
          timeOut: 2500,
        });
        this.NIOIdSearch = [];
      }
    },

    // نام استایل سطرهای جدول
    className(checkEdit, NIOId) {
      if (checkEdit == true) {
        // سطر در حال ویرایش
        return "bg-primary-light";
      } else {
        if (this.selectRowID == NIOId) {
          // سطر در حال انتخاب
          return "selRow";
        } else {
          return "selShow";
        }
      }
    },

    // بررسی وضعیت فعال یا غیرفعال بودن کادر طرف حساب
    // مرکز هزینه و قراردادها
    checkEnabelTarafHesab(NAccType, NPerID) {
      this.NAccType = NAccType;
      this.NPerID = NPerID;
      setTimeout(() => {
        // بررسی وضعیت نوع حساب
        if (NAccType == 0) {
          // ثبت طرف حساب اختیاری است
          this.checkDisabledTarafHesab = false;
          // ثبت بدهکار فعال شود
          this.checkDisabledNDebit = false;
          // ثبت بستانکار فعال شود
          this.checkDisabledNCredit = false;
          // نیاز به ثبت مرکز هزینه نمی باشد
          this.checkDisabledMarkazHazine = true;
          this.newBaseUserPlace_NCode = 0;
          // ثبت قراردادها فعال شود
          this.checkDisabledGharardad = false;
        } else if (NAccType == 1) {
          // نیازی به ثبت طرف حساب نیست
          this.checkDisabledTarafHesab = true;
          // نیازی به ثبت بدهکار نیست
          if (this.NPerID != this.newNAccCode_NCode) {
            this.checkDisabledNDebit = true;
            this.newNDebit = 0;
          }
          // بستانکار ثبت شود
          this.checkDisabledNCredit = false;
          // کد طرف حساب خالی شود
          this.newNPerID_NPerID = 0;
          // نیاز به ثبت مرکز هزینه نیست
          this.checkDisabledMarkazHazine = true;
          this.newBaseUserPlace_NCode = 0;
          // نیاز به ثبت قراردادها نیست
          this.checkDisabledGharardad = true;
          this.newBaseAgreement_NAgrID = 0;
        } else if (NAccType == 2) {
          // ثبت طرف حساب اجباری است
          this.checkDisabledTarafHesab = false;
          // بدهکار ثبت شود
          this.checkDisabledNDebit = false;
          // نیازی به ثبت بستانکار نیست
          if (this.NPerID != this.newNAccCode_NCode) {
            this.checkDisabledNCredit = true;
            this.newNCredit = 0;
          }
          // ثبت مرکز هزینه فعال شود
          this.checkDisabledMarkazHazine = false;
          // نیاز به ثبت قراردادها نیست
          this.checkDisabledGharardad = true;
          this.newBaseAgreement_NAgrID = 0;
        } else {
          // ثبت طرف حساب فعال شود
          this.checkDisabledTarafHesab = false;
          // ثبت بدهکار فعال شود
          this.checkDisabledNDebit = false;
          // ثبت بستانکار فعال شود
          this.checkDisabledNCredit = false;
          // ثبت مرکز هزینه فعال شود
          this.checkDisabledMarkazHazine = false;
          // ثبت قراردادها فعال شود
          this.checkDisabledGharardad = false;
        }
      }, this.setTimeoutDelay);
    },

    // مخفی کردن کومبوی کد حساب و طرف حساب
    HideFilterModal() {
      this.isShowFilterHesabCode = false;
      this.isShowFilterTarafHesab = false;
      this.isShowFilterBaseUsePlace = false;
      this.isShowFilterBaseAgreement = false;
      this.isShowFilterSDocDesc = false;
      this.isShowFilterSAccDesc = false;
    },

    HideShowFilterSDocDesc() {
      this.isShowFilterSDocDesc = false;
    },

    // مخفی کردن تمامی مودال ها
    HideAllModal() {
      // مخفی کردن مودال لیست حساب
      this.isShowModalHesabCode = false;
      // مخفی کردن مودال طرف حساب
      this.isShowModalTarafHesab = false;
      // مخفی کردن مودال مرکز هزینه
      this.isShowModalBaseUsePlace = false;
      // مخفی کردن مودال قراردادها
      this.isShowModalBaseAgreement = false;
    },

    // مدیریت انتقال فوکوس به کنترل ها
    // بگو کجا هستی تا بگم کجا باید بری
    ManageFocusText(currentName, changeFocus) {
      if (changeFocus == true) {
        // انتقال فوکوس به کنترل بعدی
        setTimeout(() => {
          // کادر کد حساب
          if (currentName === "NCode") {
            if (this.NAccType == 1) {
              // طرف حساب غیر فعال است
              // بدهکار غیر فعال است
              // انتقال فوکوس به بستانکار
              $("#textNCredit").focus();
            } else {
              // انتقال فوکوس به طرف حساب
              $("#textTarafHesab").focus();
            }
          }
          // کادر طرف حساب
          else if (currentName === "NPerID") {
            if (this.NAccType == 1) {
              // انتقال فوکوس به بستانکار
              $("#textNCredit").focus();
            } else if (this.NAccType == 2) {
              // انتقال فوکوس به مرکز هزینه
              $("#textBaseUsePlace").focus();
            } else {
              // انتقال فوکوس به بدهکار
              $("#textNDebit").focus();
            }
          }
          // کادر مرکز هزینه
          else if (currentName === "BaseUsePlace") {
            if (this.NAccType == 1) {
              // انتقال فوکوس به بستانکار
              $("#textNCredit").focus();
            } else if (this.NAccType == 0) {
              // انتقال فوکوس به بدهکار
              $("#textNDebit").focus();
            } else {
              // انتقال فوکوس به بدهکار
              $("#textNDebit").focus();
            }
          }
          // کادر قراردادها
          else if (currentName === "BaseAgreement") {
            if (this.NAccType == 1) {
              // انتقال فوکوس به بستانکار
              $("#textNCredit").focus();
            } else if (this.NAccType == 0) {
              // انتقال فوکوس به بدهکار
              $("#textNDebit").focus();
            } else {
              // انتقال فوکوس به بدهکار
              $("#textNDebit").focus();
            }
          }
          // کادر بدهکار
          else if (currentName === "NDebit") {
            if (this.NAccType == 1) {
              // انتقال فوکوس به بستانکار
              $("#textNCredit").focus();
            } else {
              // انتقال فوکوس به شرح حساب
              $("#textSharheHesab").focus();
            }
          }
          // کادر بستانکار
          else if (currentName === "NCredit") {
            // انتقال فوکوس به شرح حساب
            $("#textSharheHesab").focus();
          }
          // کادر شرح حساب
          else if (currentName === "SAccDesc") {
            // انتقال فوکوس به کد حساب
            $("#textHesabCode").focus();
          }
        }, this.setTimeoutDelay);
      } else {
        // انتقال فوکوس به کنترل جاری
        setTimeout(() => {
          // کادر کد حساب
          if (currentName === "NCode") {
            $("#textHesabCode").focus();
          }
          // کادر طرف حساب
          else if (currentName === "NPerID") {
            $("#textTarafHesab").focus();
          }
          // کادر مرکز هزینه
          else if (currentName === "BaseUsePlace") {
            $("#textBaseUsePlace").focus();
          }
          // کادر قراردادها
          else if (currentName === "BaseAgreement") {
            $("#textBaseAgreement").focus();
          }
          // کادر بدهکار
          else if (currentName === "NDebit") {
            $("#textNDebit").focus();
          }
          // کادر بستانکار
          else if (currentName === "NCredit") {
            $("#textNCredit").focus();
          }
          // کادر شرح حساب
          else if (currentName === "SAccDesc") {
            $("#textSharheHesab").focus();
          }
        }, this.setTimeoutDelay);
      }
    },

    // انتقال فوکوس به کنترل مورد نظر
    ChangeFocusText(name) {
      // مخفی کردن کومبوی کد حساب و طرف حساب
      this.HideFilterModal();
      // name : نام فیلد معادل در بانک اطلاعات
      setTimeout(() => {
        // کادر کد حساب
        if (name === "NCode") {
          $("#textHesabCode").focus();
        }
        // کادر طرف حساب
        else if (name === "NPerID") {
          if (this.checkDisabledTarafHesab == false)
            $("#textTarafHesab").focus();
          else {
            this.newNPerID_NPerID = 0;
            $("#textSharheHesab").focus();
          }
        }
        // کادر مرکز هزینه
        else if (name === "BaseUsePlace") {
          $("#textBaseUsePlace").focus();
        }
        // کادر قراردادها
        else if (name === "BaseAgreement") {
          $("#textBaseAgreement").focus();
        }
        // کادر شرح حساب
        else if (name === "SAccDesc") $("#textSharheHesab").focus();
        // کادر بدهکار
        else if (name === "NDebit") {
          if (this.checkDisabledNDebit == false) $("#textNDebit").focus();
          else {
            this.newNDebit = 0;
            $("#textNCredit").focus();
          }
        }
        // کادر بستانکار
        else if (name === "NCredit") {
          if (this.checkDisabledNCredit == false) $("#textNCredit").focus();
          else {
            this.newNCredit = 0;
            $("#textSharheHesab").focus();
          }
        }
      }, this.setTimeoutDelay);
    },

    // نمایش مودال کد حساب و طرف حساب ها
    ShowModal(modalName, isShowByMenu = false) {
      // مخفی کردن کادر لیست حساب
      this.HideFilterModal();
      // مخفی کردن تمام مودال ها
      this.HideAllModal();
      // غیرفعال سازی کلید میانبرها
      this.HotKeyEnable = false;
      if (modalName === "HesabCode") {
        // if (isShowByMenu == true || this.getHesabNameByNewOrEditRow(this.newNAccCode_NCode) === "") {
        this.isShowModalHesabCode = true;
        setTimeout(() => {
          $("#modal-hesab-code").modal("show");
          // فیلتر لیست بر اساس مقدار درج شده کاربر
          BusEvent.$emit("setFocusetextHesabSearch", this.newNAccCode_NCode);
        }, this.setTimeoutDelay);
        // } else {
        //   // مدیریت انتقال فوکوس بر اساس نوع حساب
        //   this.ManageFocusText("NCode", true);
        // }
      } else if (modalName === "TarafHesab") {
        // if (isShowByMenu == true || this.getTarafHesabName(this.newNPerID_NPerID) === "") {
        this.isShowModalTarafHesab = true;
        setTimeout(() => {
          $("#modal-taraf-hesab").modal("show");
          // فیلتر لیست بر اساس مقدار درج شده کاربر
          BusEvent.$emit(
            "setFocusetextSearchTarafHesab",
            this.newNPerID_NPerID
          );
        }, this.setTimeoutDelay);
        // } else {
        //   // مدیریت انتقال فوکوس بر اساس نوع حساب
        //   this.ManageFocusText("NPerID", true);
        // }
      } else if (modalName === "BaseUsePlace") {
        // if (isShowByMenu == true || this.getSUsePlaceName(this.newBaseUserPlace_NCode) === "") {
        this.isShowModalBaseUsePlace = true;
        setTimeout(() => {
          $("#modal-base-useplace").modal("show");
          // فیلتر لیست بر اساس مقدار درج شده کاربر
          BusEvent.$emit(
            "setFocuseTextSearchBaseUsePlace",
            this.newBaseUserPlace_NCode
          );
        }, this.setTimeoutDelay);
        // } else {
        //   // انتقال فوکوس به کادر بدهکار
        //   //this.ChangeFocusText("NDebit");
        //   this.ManageFocusText("BaseUsePlace", true);
        // }
      } else if (modalName === "BaseAgreement") {
        // if (isShowByMenu == true || this.getSAgreementName(this.newBaseAgreement_NAgrID) === "") {
        this.isShowModalBaseAgreement = true;
        setTimeout(() => {
          $("#modal-base-agreement").modal("show");
          // فیلتر لیست بر اساس مقدار درج شده کاربر
          BusEvent.$emit(
            "setFocuseTextSearchBaseAgreement",
            this.newBaseAgreement_NAgrID
          );
        }, this.setTimeoutDelay);
        // } else {
        //   // انتقال فوکوس به کادر بدهکار
        //   //this.ChangeFocusText("NDebit");
        //   this.ManageFocusText("BaseAgreement", true);
        // }
      }
    },

    // بسته شدن مودال کد حساب
    HideModalHesabCode(event) {
      if (event.NCode != 0) {
        // دریافت کد حساب از مودال
        this.newNAccCode_NCode = event.NCode;
        this.newNAccCode_SDesc = event.SDesc;
        this.newNAccCode_NAccType = event.NAccType;
        // بررسی وضعیت فعال بودن کادر طرف حساب
        this.checkEnabelTarafHesab(event.NAccType, event.NPerID);
        this.ManageFocusText("NCode", true);
      } else {
        // انصراف از نمایش مودال بدون انتخاب کد حساب
        // انتخاب کادر کد حساب
        //this.ChangeFocusText("NCode");
        this.ManageFocusText("NCode", false);
      }
      // فعال سازی کلید میانبرها
      this.HotKeyEnable = true;
      // مخفی کردن کادر لیست حساب
      this.HideFilterModal();
      // مخفی کردن تمام مودال ها
      this.HideAllModal();
    },

    // بسته شدن مودال طرف حساب
    HideModalTarafHesab(event) {
      if (event.NPerID != 0) {
        this.newNPerID_NPerID = event.NPerID;
        this.newNPerID_NPerName = event.NPerName;
        this.newNPerID_NPerLastName = event.NPerLastName;
        this.newNPerID_NPerType = event.NPerType;

        // انتخاب کادر شرح حساب
        //this.ChangeFocusText("SAccDesc");
        this.ManageFocusText("NPerID", true);
      } else {
        // انصراف از نمایش مودال بدون انتخاب طرف حساب
        // انتخاب کادر طرف حساب
        //this.ChangeFocusText("NPerID");
        this.ManageFocusText("NPerID", false);
      }
      // فعال سازی کلید میانبرها
      this.HotKeyEnable = true;
      // مخفی کردن کادر لیست حساب
      this.HideFilterModal();
      // مخفی کردن تمام مودال ها
      this.HideAllModal();
    },

    // بسته شدن مودال مرکز هزینه
    HideModalBaseUsePlace(event) {
      if (event.NCode != 0) {
        this.newBaseUserPlace_NCode = event.NCode;
        this.newBaseUserPlace_SDesc = event.SDesc;
        this.newBaseUserPlace_SDate = event.SDate;

        // انتخاب کادر قراردادها
        //this.ChangeFocusText("BaseAgreement");
        this.ManageFocusText("BaseUsePlace", true);
      } else {
        // انصراف از نمایش مودال بدون انتخاب مرکز هزینه
        // انتخاب کادر مرکز هزینه
        //this.ChangeFocusText("BaseUsePlace");
        this.ManageFocusText("BaseUsePlace", false);
      }

      // فعال سازی کلید میانبرها
      this.HotKeyEnable = true;
      // مخفی کردن کادر لیست حساب
      this.HideFilterModal();
      // مخفی کردن تمام مودال ها
      this.HideAllModal();
    },

    // بسته شدن مودال قرادادها
    HideModalBaseAgreement(event) {
      if (event.NAgrID != 0) {
        this.newBaseAgreement_NAgrID = event.NAgrID;
        // this.newBaseUserPlace_SDesc = event.SDesc;
        // this.newBaseUserPlace_SDate = event.SDate;

        // انتخاب کادر بدهکار
        //this.ChangeFocusText("NDebit");
        this.ManageFocusText("BaseAgreement", true);
      } else {
        // انصراف از نمایش مودال بدون انتخاب مرکز هزینه
        // انتخاب کادر مرکز هزینه
        //this.ChangeFocusText("BaseAgreement");
        this.ManageFocusText("BaseAgreement", false);
      }

      // فعال سازی کلید میانبرها
      this.HotKeyEnable = true;
      // مخفی کردن کادر لیست حساب
      this.HideFilterModal();
      // مخفی کردن تمام مودال ها
      this.HideAllModal();
    },

    // بسته شدن لیست کشویی شرح سند
    HideFilterSDocDesc(event) {
      if (event.NCode != 0) {
        this.AccDocData.SDocDesc = event.SDesc;

        // بستن لیست کشویی شرح سند
        this.isShowFilterSDocDesc = false;
        // در سند تغییر رخ داده است
        this.setChangeAccDocData();
      } else {
        // بستن لیست کشویی شرح سند
        this.isShowFilterSDocDesc = false;
      }

      // فعال سازی کلید میانبرها
      this.HotKeyEnable = true;
      // مخفی کردن کادر لیست حساب
      this.HideFilterModal();
      // مخفی کردن تمام مودال ها
      this.HideAllModal();
    },

    // بسته شدن لیست کشویی شرح حساب - شرح ردیف
    HideFilterSAccDesc(event) {
      if (event.NCode != 0) {
        this.newSAccDesc = event.SDesc;

        // بستن لیست کشویی شرح سند
        this.isShowFilterSAccDesc = false;
        // در سند تغییر رخ داده است
        this.setChangeAccDocData();
      } else {
        // بستن لیست کشویی شرح سند
        this.isShowFilterSAccDesc = false;
      }

      // فعال سازی کلید میانبرها
      this.HotKeyEnable = true;
      // مخفی کردن کادر لیست حساب
      this.HideFilterModal();
      // مخفی کردن تمام مودال ها
      this.HideAllModal();
    },

    // مرتب سازی لیست بر اساس فیلد انتخابی
    sortDocRow: function (sortFieldName, sortFieldType) {
      // منبع مطلب
      // https://www.codegrepper.com/code-examples/javascript/frameworks/vue/Sort+numbers+in+javascript
      let docrow = this.AccDocData.ListTbAccDocRecord;
      // بررسی وضعیت مرتب سازی صعودی یا نزولی
      if (sortFieldType === "") {
        if (this.lastSortFieldName === sortFieldName) {
          // فیلد تکراری است لذا مرتب سازی از بزرگ به کوچک
          sortFieldType = "desc";
          // تخلیه نام آخرین فیلد مرتب سازی شده
          this.lastSortFieldName = "";
        } else {
          // فیلد جدید است لذا مرتب سازی از کوچک به بزرگ
          sortFieldType = "asc";
          // نگهداری نام آخرین فیلد مرتب سازی شده
          this.lastSortFieldName = sortFieldName;
        }
      }

      // Set slice() to avoid to generate an infinite loop!
      if (docrow.length > 0) {
        if (sortFieldName === "NIOId") {
          // شماره ردیف
          // مرتب سازی فیلد عددی
          this.AccDocData.ListTbAccDocRecord = docrow
            .slice()
            .sort(function (a, b) {
              if (sortFieldType === "asc")
                // کوچک به بزرگ
                return a.NIOId - b.NIOId;
              // بزرگ به کوچک
              else return b.NIOId - a.NIOId;
            });
        }
        if (sortFieldName === "NAccCode") {
          // کد حساب
          // مرتب سازی فیلد عددی
          this.AccDocData.ListTbAccDocRecord = docrow
            .slice()
            .sort(function (a, b) {
              if (sortFieldType === "asc")
                // کوچک به بزرگ
                return a.NAccCode - b.NAccCode;
              // بزرگ به کوچک
              else return b.NAccCode - a.NAccCode;
            });
        } else if (sortFieldName === "SAccCode") {
          // عنوان کد حساب
          // مرتب سازی فیلد متنی
          this.AccDocData.ListTbAccDocRecord = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SAccCode;
              f2 = b.SAccCode;
            } else {
              f1 = b.SAccCode;
              f2 = a.SAccCode;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "NPerID") {
          // کد طرف حساب
          // مرتب سازی فیلد عددی
          this.AccDocData.ListTbAccDocRecord = docrow
            .slice()
            .sort(function (a, b) {
              if (sortFieldType === "asc")
                // کوچک به بزرگ
                return a.NPerID - b.NPerID;
              // بزرگ به کوچک
              else return b.NPerID - a.NPerID;
            });
        } else if (sortFieldName === "LName") {
          // عنوان طرف حساب
          // مرتب سازی فیلد متنی
          this.AccDocData.ListTbAccDocRecord = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.LName;
              f2 = b.LName;
            } else {
              f1 = b.LName;
              f2 = a.LName;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "NUsePlace") {
          // کد مرکز هزینه
          // مرتب سازی فیلد عددی
          this.AccDocData.ListTbAccDocRecord = docrow
            .slice()
            .sort(function (a, b) {
              if (sortFieldType === "asc")
                // کوچک به بزرگ
                return a.NUsePlace - b.NUsePlace;
              // بزرگ به کوچک
              else return b.NUsePlace - a.NUsePlace;
            });
        } else if (sortFieldName === "SUsePlace") {
          // عنوان مرکز هزینه
          // مرتب سازی فیلد متنی
          this.AccDocData.ListTbAccDocRecord = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SUsePlace;
              f2 = b.SUsePlace;
            } else {
              f1 = b.SUsePlace;
              f2 = a.SUsePlace;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "NAgrID") {
          // کد قراردادها
          // مرتب سازی فیلد عددی
          this.AccDocData.ListTbAccDocRecord = docrow
            .slice()
            .sort(function (a, b) {
              if (sortFieldType === "asc")
                // کوچک به بزرگ
                return a.NAgrID - b.NAgrID;
              // بزرگ به کوچک
              else return b.NAgrID - a.NAgrID;
            });
        } else if (sortFieldName === "SAgreement") {
          // عنوان قراردادها
          // مرتب سازی فیلد متنی
          this.AccDocData.ListTbAccDocRecord = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SAgreement;
              f2 = b.SAgreement;
            } else {
              f1 = b.SAgreement;
              f2 = a.SAgreement;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "NDebit") {
          // بدهکار
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.AccDocData.ListTbAccDocRecord = docrow.sort(
              (a, b) => a.NDebit - b.NDebit
            );
          else
            this.AccDocData.ListTbAccDocRecord = docrow.sort(
              (a, b) => b.NDebit - a.NDebit
            );
        } else if (sortFieldName === "NCredit") {
          // بستانکار
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.AccDocData.ListTbAccDocRecord = docrow.sort(
              (a, b) => a.NCredit - b.NCredit
            );
          else
            this.AccDocData.ListTbAccDocRecord = docrow.sort(
              (a, b) => b.NCredit - a.NCredit
            );
        }
      } else {
        return [];
      }
    },

    // فعال سازی درج سطر جدید
    callNewRow() {
      // لغو ویرایش های قبلی
      this.cancelEditRow(this.editNIOId);
      // فعال سازی درج سطر جدید
      this.checkNewRow = true;
      // غیرفعال سازی کلید میانبرهای جهت نما
      this.ArrowKeyEnable = false;
      // بررسی وضعیت حساب سند
      if (this.SumAmountRow.AlignmentStatus == false) {
        let sumDebit = this.SumAmountRow.SumNDebit;
        let sumCredit = this.SumAmountRow.SumNCredit;
        if (sumDebit > sumCredit) {
          // اگر جمع بدهکار بیشتر از بستانکار بود به بستانکار اضافه شود
          this.newNCredit = (sumDebit - sumCredit)
            .toString()
            .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        } else if (sumCredit > sumDebit) {
          // اگر بستانکار بزرگتر از بدهکار به بدهکار اضافه شود
          this.newNDebit = (sumCredit - sumDebit)
            .toString()
            .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        }
      }
      // انتقال فوکوس به داخل کادر کد حساب
      this.ChangeFocusText("NCode");
    },

    // انصراف از ثبت سطر جدید
    cancelNewRow() {
      this.newNAccCode_NCode = 0;
      this.newNAccCode_SDesc = "";
      this.newNAccCode_NAccType = 0;

      this.newNPerID_NPerID = 0;
      this.newNPerID_NPerName = "";
      this.newNPerID_NPerLastName = "";
      this.newNPerID_NPerType = 0;

      this.newBaseUserPlace_NCode = 0;
      this.newBaseAgreement_NAgrID = 0;

      this.newBaseUserPlace_NCode = 0;
      this.newBaseAgreement_NAgrID = 0;

      this.newSAccDesc = "";
      this.newNDebit = 0;
      this.newNCredit = 0;
      // لغو نمایش سطر جدید
      this.checkNewRow = false;
      // فعال کردن کلید میانبرهای جهت نما
      this.ArrowKeyEnable = true;
      // مخفی کردن کادر لیست حساب
      this.HideFilterModal();
      // غیرفعال کردن طرف حساب ، مرکز هزینه و قراردادها
      this.checkDisabledTarafHesab = true;
      this.checkDisabledMarkazHazine = true;
      this.checkDisabledGharardad = true;
    },

    // تابع درج سطر جدید
    saveNewRow() {
      var checkInvalid = this.invalidEditCheck(
        this.newNAccCode_NCode,
        this.newNPerID_NPerID,
        true
      );
      if (checkInvalid.state == true) {
        var NIOId = 1;
        if (this.AccDocData.ListTbAccDocRecord.length > 0) {
          NIOId = parseInt(this.AccDocData.ListTbAccDocRecord[0].NIOId) + 1;
        }
        // درج مقادیر سطر جدید در جدول
        this.AccDocData.ListTbAccDocRecord.push({
          Code: NIOId,
          NIOId: NIOId,
          NAccCode: this.newNAccCode_NCode,
          SAccCode: this.getHesabName(this.newNAccCode_NCode),
          NPerID: this.newNPerID_NPerID,
          LName: this.getTarafHesabName(this.newNPerID_NPerID),
          NUsePlace: this.newBaseUserPlace_NCode,
          SUsePlace: this.getSUsePlaceName(
            this.newBaseUserPlace_NCode
          ),
          NAgrID: this.newBaseAgreement_NAgrID,
          SAgreement: this.getSAgreementName(
            this.newBaseAgreement_NAgrID
          ),
          SAccDesc: this.newSAccDesc.trim(),
          NDebit: this.newNDebit.toString().replace(/,/gi, ""),
          NCredit: this.newNCredit.toString().replace(/,/gi, ""),
          checkEdit: false,
        });

        // خالی کردن مقادیر سطر جدید
        this.newNAccCode_NCode = 0;
        this.newNAccCode_SDesc = "";
        this.newNAccCode_NAccType = 0;

        this.newNPerID_NPerID = 0;
        this.newNPerID_NPerName = "";
        this.newNPerID_NPerLastName = "";
        this.newNPerID_NPerType = 0;

        this.newBaseUserPlace_NCode = 0;
        this.newBaseAgreement_NAgrID = 0;

        this.newSAccDesc = "";
        this.newNDebit = 0;
        this.newNCredit = 0;

        // مخفی کردن سطر جدید
        this.checkNewRow = false;
        // در سند تغییر رخ داده است
        // this.AccDocData.CheckChangeData = true;
        // this.setChangeDataInTab(this.tabData.TabID);
        // اگر سند جدید است : غیرفعال کردن شماره و شناسه سند
        // this.setDisabledDocID();
        // ثبت وجود تغییرات در سند
        this.setChangeAccDocData();
        // فعال کردن کلید میانبرهای جهت نما
        this.ArrowKeyEnable = true;
        // محاسبه جمع ستون های بدهکار و بستانکار
        this.calcSumAmountRow();
        // مرتب سازی مقادیر سطرهای سند
        this.sortDocRow("NIOId", "desc");

        // ذخیره تغییرات محلی
        //this.saveLocalData();
        // مخفی کردن کادر لیست حساب
        this.HideFilterModal();
      } else {
        this.$store.dispatch("notify", {
          notText: checkInvalid.text,
          timeOut: 2500,
        });
      }
    },

    // فعال سازی ویرایش سطر
    async callEditRow(NIOId) {
      // لغو ویرایش های قبلی
      this.cancelEditRow(this.editNIOId);
      // مخفی کردن سطر جدید
      this.checkNewRow = false;
      // جستجوی مقادیر سطر مورد نظر
      let index = this.AccDocData.ListTbAccDocRecord.findIndex(
        (itme) => itme.NIOId == NIOId
      );
      if (index != -1) {
        // بازیابی مقادیر سطر مورد نظر

        // بازیابی اطلاعات کد حساب
        var hesabData = await this.$store.getters.getTbBaseAccDataNameAndType(
          this.AccDocData.ListTbAccDocRecord[index].NAccCode
        );
        this.newNAccCode_NCode = hesabData.NCode;
        this.newNAccCode_SDesc = hesabData.SDesc;
        this.newNAccCode_NAccType = hesabData.NAccType;
        // بررسی وضعیت فعال بودن کادر طرف حساب
        this.checkEnabelTarafHesab(hesabData.NAccType, hesabData.NPerID);

        // بازیابی اطلاعات طرف حساب
        var tarafData = this.$store.getters.getTbPersonDataNameAndType(
          this.AccDocData.ListTbAccDocRecord[index].NPerID
        );
        this.newNPerID_NPerID = tarafData.NPerID;
        this.newNPerID_NPerName = tarafData.NPerName;
        this.newNPerID_NPerLastName = tarafData.NPerLastName;
        this.newNPerID_NPerType = tarafData.NPerType;

        this.newBaseUserPlace_NCode =
          this.AccDocData.ListTbAccDocRecord[index].NUsePlace;
        this.newBaseAgreement_NAgrID =
          this.AccDocData.ListTbAccDocRecord[index].NAgrID;
        // this.newBaseUserPlace_SDesc = this.AccDocData.ListTbAccDocRecord[index].SDesc;
        // this.newBaseUserPlace_SDate = this.AccDocData.ListTbAccDocRecord[index].SDate;

        this.newSAccDesc = this.AccDocData.ListTbAccDocRecord[index].SAccDesc;
        this.newNDebit = this.AccDocData.ListTbAccDocRecord[
          index
        ].NDebit.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        this.newNCredit = this.AccDocData.ListTbAccDocRecord[
          index
        ].NCredit.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        // نمایش سطر در وضعیت ویرایش
        this.AccDocData.ListTbAccDocRecord[index].checkEdit = true;
        // نگهداری شماره سطر در حال ویرایش
        this.editNIOId = NIOId;
        // غیرفعال کردن کلید میانبرهای جهت نما
        this.ArrowKeyEnable = false;
        // انتقال فوکوس به داخل کادر کد حساب
        this.ChangeFocusText("NCode");
      }
    },

    // انصراف از ویرایش
    cancelEditRow(NIOId) {
      this.newNAccCode_NCode = 0;
      this.newNAccCode_SDesc = "";
      this.newNAccCode_NAccType = 0;

      this.newNPerID_NPerID = 0;
      this.newNPerID_NPerName = "";
      this.newNPerID_NPerLastName = "";
      this.newNPerID_NPerType = 0;

      this.newBaseUserPlace_NCode = 0;
      this.newBaseAgreement_NAgrID = 0;

      this.newBaseUserPlace_NCode = 0;
      this.newBaseUserPlace_SDesc = "";
      this.newBaseUserPlace_SDate = "";

      this.newSAccDesc = "";
      this.newNDebit = 0;
      this.newNCredit = 0;

      if (this.AccDocData.ListTbAccDocRecord.length > 0) {
        // غیر فعال کردن حالت ویرایش سطر مورد نظر
        let index = this.AccDocData.ListTbAccDocRecord.findIndex(
          (itme) => itme.NIOId == NIOId
        );
        if (index != -1) {
          this.AccDocData.ListTbAccDocRecord[index].checkEdit = false;
        }
      }
      // خالی کردن شماره سطر در حال ویرایش
      this.editNIOId = 0;
      // فعال کردن کلید میانبرهای جهت نما
      this.ArrowKeyEnable = true;
      // مخفی کردن کادر لیست حساب
      this.HideFilterModal();
      // غیرفعال کردن طرف حساب ، مرکز هزینه و قراردادها
      this.checkDisabledTarafHesab = true;
      this.checkDisabledMarkazHazine = true;
      this.checkDisabledGharardad = true;
    },

    // ویرایش اطلاعات سطر
    saveEditRow(NIOId) {
      let index = this.AccDocData.ListTbAccDocRecord.findIndex(
        (itme) => itme.NIOId == NIOId
      );
      if (index != -1) {
        var checkInvalid = this.invalidEditCheck(
          this.newNAccCode_NCode,
          this.newNPerID_NPerID,
          true
        );
        if (checkInvalid.state == true) {
          this.AccDocData.ListTbAccDocRecord[index].NAccCode =
            this.newNAccCode_NCode;
          this.AccDocData.ListTbAccDocRecord[index].SAccCode =
            this.getHesabName(this.newNAccCode_NCode);
          this.AccDocData.ListTbAccDocRecord[index].NPerID =
            this.newNPerID_NPerID;
          this.AccDocData.ListTbAccDocRecord[index].LName =
            this.getTarafHesabName(this.newNPerID_NPerID);
          // ذخیره کد مرکز هزینه
          this.AccDocData.ListTbAccDocRecord[index].NUsePlace =
            this.newBaseUserPlace_NCode;
          this.AccDocData.ListTbAccDocRecord[index].SUsePlace =
            this.getSUsePlaceName(this.newBaseUserPlace_NCode);
          // ذخیره کد قرارداد
          this.AccDocData.ListTbAccDocRecord[index].NAgrID =
            this.newBaseAgreement_NAgrID;
          this.AccDocData.ListTbAccDocRecord[index].SAgreement =
            this.getSAgreementName(this.newBaseAgreement_NAgrID);

          this.AccDocData.ListTbAccDocRecord[index].SAccDesc =
            this.newSAccDesc.trim();
          this.AccDocData.ListTbAccDocRecord[index].NDebit = this.newNDebit
            .toString()
            .replace(/,/gi, "");
          this.AccDocData.ListTbAccDocRecord[index].NCredit = this.newNCredit
            .toString()
            .replace(/,/gi, "");
          // مخفی کردن حالت ویرایش
          this.AccDocData.ListTbAccDocRecord[index].checkEdit = false;
          // در سند تغییری رخ داده است
          // this.AccDocData.CheckChangeData = true;
          // this.setChangeDataInTab(this.tabData.TabID);
          // اگر سند جدید است : غیرفعال کردن شماره و شناسه سند
          // this.setDisabledDocID();
          // ثبت وجود تغییرات در سند
          this.setChangeAccDocData();
          // خالی کردن شماره سطر در حال ویرایش
          this.editNIOId = 0;
          // فعال کردن کلید میانبرهای جهت نما
          this.ArrowKeyEnable = true;
          // محاسبه جمع ستون های بدهکار و بستانکار
          this.calcSumAmountRow();
          // ذخیره تغییرات محلی
          //this.saveLocalData();
          // مخفی کردن کادر لیست حساب
          this.HideFilterModal();
        } else {
          this.$store.dispatch("notify", {
            notText: checkInvalid.text,
            timeOut: 2500,
          });
        }
      }
    },

    // تابع حذف سطر
    deleteRow() {
      if (this.showCheckBoxDeleteRow == true) {
        let NIOId = this.selectRowID;
        if (this.checkedRowSelect.length == 0) {
          // حذف سطر جاری
          swal({
            title: "حذف سطر انتخابی",
            text:
              "شما تقاضا حذف سطر شماره " +
              NIOId +
              " را کرده اید . آیا ادامه می دهید؟",
            icon: "warning", // success, warning, error, info
            buttons: {
              cancel: "انصراف",
              ok: "بله سطر انتخابی حذف شود",
            },
          }).then(async (value) => {
            if (value) {
              // حذف سطر مورد نظر
              this.AccDocData.ListTbAccDocRecord =
                this.AccDocData.ListTbAccDocRecord.filter(function (t) {
                  return t.NIOId != NIOId;
                });
              // در سند تغییر رخ داده است
              this.setChangeAccDocData();
              // محاسبه جمع ستون های بدهکار و بستانکار
              this.calcSumAmountRow();
              // مخفی کردن چک باکس های حذف ردیف
              // this.showCheckBoxDeleteRow = false;
              //
              this.selectRowID--;
            }
          });
        } else {
          // حذف تمام سطرهای در حال انتخاب
          swal({
            title: "حذف سطرهای انتخابی",
            text:
              "شما تقاضا حذف " +
              this.checkedRowSelect.length +
              " سطر از اطلاعات را کرده اید . آیا ادامه می دهید؟",
            icon: "warning", // success, warning, error, info
            buttons: {
              cancel: "انصراف",
              ok: "بله سطرهای انتخابی حذف شوند",
            },
          }).then(async (value) => {
            if (value) {
              for (var i = 0; i < this.checkedRowSelect.length; i++) {
                NIOId = this.checkedRowSelect[i];
                // حذف سطر مورد نظر
                this.AccDocData.ListTbAccDocRecord =
                  this.AccDocData.ListTbAccDocRecord.filter(function (t) {
                    return t.NIOId != NIOId;
                  });
              }

              // در سند تغییر رخ داده است
              this.setChangeAccDocData();
              // محاسبه جمع ستون های بدهکار و بستانکار
              this.calcSumAmountRow();
              // خالی کردن لیست چک باکس
              this.checkedRowSelect = [];
              // مخفی کردن چک باکس های حذف ردیف
              this.showCheckBoxDeleteRow = false;
            }
          });
        }
      } else {
        this.showCheckBoxDeleteRow = true;
      }
    },

    // تابع بازسازی شماره ردیف ها
    updateNIOId() {
      if (this.AccDocData.ListTbAccDocRecord.length > 0) {
        let rowNum = 1;
        this.AccDocData.ListTbAccDocRecord.forEach((element) => {
          element.NIOId = rowNum;
          rowNum++;
        });
        // مرتب سازی مقادیر سطرهای سند
        this.sortDocRow("NIOId", "desc");
        // در سند تغییر رخ داده است
        // this.AccDocData.CheckChangeData = true;
        // this.setChangeDataInTab(this.tabData.TabID);
        // ثبت وجود تغییرات در سند
        this.setChangeAccDocData();
        // ذخیره تغییرات محلی
        //this.saveLocalData();
      }
    },

    // اعلام تغییر در محتوای تب به والد
    setChangeDataInTab(tabID, blnCheckSave = true) {
      this.$store.commit("setChangeDataInTab", {
        tabID,
        tabDataForChange: {
          NId: this.tabData.NId,
          NDocNu: this.tabData.NDocNu,
          LocalData: false,
          TabAccDocData: {},
          CheckChangeData: blnCheckSave,
        },
      });
      // اگر تغییرات مثبت بود
      if (blnCheckSave == true) {
        // ذخیره اطلاعات در مرورگر
        this.saveLocalData();
        // در صورت لزوم ، در این مرحله باید به سرور اعلام شود که در سند تغییری
        // رخ داده است و اطلاعات در لوکال فلان کاربر ذخیره شده است

        // ...
      }
    },

    // بررسی وضعیت مجاز برای ذخیره تغییرات
    invalidEditCheck(NAccCode, NPerID, setfocus = false) {
      // ریست وضعیت اعتبارسنجی
      if (setfocus == true) {
        this.newNAccCode_NCode_Invalid = false;
        this.newNPerID_NPerID_Invalid = false;
        this.newBaseAgreement_NAgrID_Invlid = false;
        this.newBaseUserPlace_NCode_Invalid = false;
        this.newNDebit_Invalid = false;
        this.newNCredit_Invalid = false;
        this.newSAccDesc_Invalid = false;
      }
      // اگر کد حساب معتبر بود
      if (this.getHesabName(NAccCode) != "") {
        // اگر ثبت طرف حساب اجباری بود
        // NAccType = 0 طرف حساب غیر اجباری
        // NAccType = 2 طرف حساب اجباری
        // NPerID = 9998101 طرف حساب اجباری
        var blnCheckTarafHesab = false;
        if (this.NAccType == 2 || this.NPerID == 9998101) {
          // اگر کد طرف حساب معتبر بود
          if (this.getTarafHesabName(NPerID) != "") {
            // return {state: true, text: ""};
            blnCheckTarafHesab = true;
          } else {
            if (setfocus) {
              this.newNPerID_NPerID_Invalid = true;
              $("#textTarafHesab").focus();
            }
            return { state: false, text: "ثبت طرف حساب اجباری است !" };
          }
        } else {
          // return {state: true, text: ""};
          blnCheckTarafHesab = true;
        }

        // اگر وضعیت طرف حساب اوکی بود ادامه بده
        if (blnCheckTarafHesab == true) {
          // اگر مقدار بدهکار یا بستانکار خالی نبود
          if (
            this.newNDebit.toString().replace(/,/gi, "") > 0 ||
            this.newNCredit.toString().replace(/,/gi, "") > 0
          ) {
            // درج شرح ردیف الزامی است
            if (this.newSAccDesc.trim() != "") {
              // همه چیز اوکی هست
              return { state: true, text: "" };
            } else {
              if (setfocus) {
                this.newSAccDesc_Invalid = true;
                $("#textSharheHesab").focus();
              }
              return { state: false, text: "درج شرح حساب الزامی است !" };
            }
          } else {
            if (setfocus) {
              if (!this.checkDisabledNDebit) {
                this.newNDebit_Invalid = true;
                $("#textNDebit").focus();
              }
              if (!this.checkDisabledNCredit) {
                this.newNCredit_Invalid = true;
                $("#textNCredit").focus();
              }
            }
            return {
              state: false,
              text:
                "درج مقدار " +
                (this.checkDisabledNDebit
                  ? "بستانکار"
                  : this.checkDisabledNCredit
                    ? "بدهکار"
                    : "بدهکار / بستانکار") +
                " اجباری است !",
            };
          }
        }
      } else {
        if (setfocus) {
          this.newNAccCode_NCode_Invalid = true;
          $("#textHesabCode").focus();
        }
        return { state: false, text: "کد حساب نامعتبر است !" };
      }
      //   // اگر مقدار بدهکار یا بستانکار خالی نبود
      //   if (
      //     this.newNDebit.toString().replace(/,/gi, "") > 0 ||
      //     this.newNCredit.toString().replace(/,/gi, "") > 0
      //   ) {
      //     // درج شرح ردیف الزامی است
      //     if(this.newSAccDesc != ""){
      //       // اگر کد حساب معتبر بود
      //       if (this.getHesabName(NAccCode) != "") {
      //         // اگر ثبت طرف حساب اجباری بود
      //         // NAccType = 0 طرف حساب غیر اجباری
      //         // NAccType = 2 طرف حساب اجباری
      //         if (this.NAccType == 2) {
      //           // اگر کد طرف حساب معتبر بود
      //           if (this.getTarafHesabName(NPerID) != "") {
      //             return {state: true, text: ""};
      //           } else {
      //             this.newNPerID_NPerID_Invalid = true;
      //             if(setfocus) $("#textTarafHesab").focus();
      //             return {state: false, text: "ثبت طرف حساب اجباری است !"};
      //           }
      //         } else {
      //           return {state: true, text: ""};
      //         }
      //       } else {
      //         this.newNAccCode_NCode_Invalid = true
      //         if(setfocus) $("#textHesabCode").focus();
      //         return {state: false, text: "کد حساب نامعتبر است !"};
      //       }
      //     } else {
      //       this.newSAccDesc_Invalid = true;
      //       if(setfocus) $("#textSharheHesab").focus();
      //       return {state: false, text: "درج شرح حساب الزامی است !"};
      //     }
      //   } else {
      //     this.newNDebit_Invalid = true;
      //     if(setfocus) $("#textNDebit").focus();
      //     return {state: false, text: "درج مقدار بدهکار / بستانکار اجباری است !"};
      //   }
      // // } else {
      // //   return {state: false, text: "مقادیر ثبت شده ، معتبر نمی باشد !"};
      // // }
    },

    // دریافت نام حساب از روی کد حساب
    getHesabName(NAccCode) {
      var TbBaseAccName = this.$store.getters.getTbBaseAccDataName(NAccCode);
      if (TbBaseAccName.SDesc != "") {
        return TbBaseAccName.SDesc;
      } else {
        return "";
      }
    },

    // دریافت نام حساب از روی کد حساب در هنگام درج سطر جدید
    getHesabNameByNewOrEditRow(NAccCode) {
      var TbBaseAccName = this.$store.getters.getTbBaseAccDataName(NAccCode);
      if (TbBaseAccName.SDesc != "") {
        if (this.checkNewRow != false || this.editNIOId != 0) {
          this.checkEnabelTarafHesab(
            TbBaseAccName.NAccType,
            TbBaseAccName.NPerID
          );
        }
        return TbBaseAccName.SDesc;
      } else {
        this.newNPerID_NPerID = 0;
        this.checkDisabledTarafHesab = true;
        this.checkDisabledNDebit = true;
        this.checkDisabledNCredit = true;
        return "";
      }
    },

    // دریافت نام طرف حساب از روی کد طرف حساب
    getTarafHesabName(NPerID) {
      if (NPerID != 0) {
        var tarafData = this.$store.getters.getTbPersonDataNameAndType(NPerID);
        var lensubstring = this.$store.getters.getLenSubString;
        return (
          tarafData.NPerName +
          (tarafData.NPerLastName != ""
            ? " / " +
            (tarafData.NPerLastName.length > lensubstring
              ? tarafData.NPerLastName.substring(0, 25) + " ..."
              : tarafData.NPerLastName)
            : "")
        );
      } else {
        return "";
      }
    },

    // دریافت نام مرکز هزینه از روی کد مرکز هزینه
    getSUsePlaceName(NUsePlace) {
      if (NUsePlace != 0) {
        var UsePlaceData = this.$store.getters.getTbBaseUsePlaceName(NUsePlace);
        var lensubstring = this.$store.getters.getLenSubString;
        return UsePlaceData.SDesc != ""
          ? UsePlaceData.SDesc.length > lensubstring
            ? UsePlaceData.SDesc.substring(0, 25) + " ..."
            : UsePlaceData.SDesc
          : "";
      } else {
        return "";
      }
    },

    // دریافت نام قرارداد از روی کد قرارداد
    getSAgreementName(NAgrID) {
      if (NAgrID != 0) {
        var UsePlaceData = this.$store.getters.getTbBaseAgreementName(NAgrID);
        var lensubstring = this.$store.getters.getLenSubString;
        return UsePlaceData.SAgrSubject != ""
          ? UsePlaceData.SAgrSubject.length > lensubstring
            ? UsePlaceData.SAgrSubject.substring(0, 25) + " ..."
            : UsePlaceData.SAgrSubject
          : "";
      } else {
        return "";
      }
    },

    checkKeySharheHesab(event) {
      if (event.key != "Alt" && event.key != "s" && event.key != "س") {
        this.newSAccDesc_Invalid = false;
      }
    },

    // درج فقط عدد مجاز است
    onlyNumber(event) {
      if (event.key === "Backspace") {
        event.preventDefault(true);
        event.stopPropagation(true);

        event.target.value = event.target.value
          .replace(/,/gi, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      } else if (event.key === "Delete") {
        event.preventDefault(true);
        event.stopPropagation(true);

        event.target.value = event.target.value
          .replace(/,/gi, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      } else if (event.key === ".") {
        // لغو مقدار ارسالی پیش فرض
        event.preventDefault(true);
        event.stopPropagation(true);
        // مقدار دهی با سه صفر
        event.target.value += "000";
        event.target.value = event.target.value.replace(".", "");
        event.target.dispatchEvent(new Event("input"));
        event.target.value = event.target.value
          .replace(/,/gi, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        // این خط باعث می شود ویو متوجه تغییر بشود
        // event.target.dispatchEvent(new Event("input"));
      } else if (!/^[0-9]+$/.test(event.key)) {
        event.target.value = event.target.value
          .replace(/[^0-9]/g, "")
          .replace(/,/gi, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      } else {
        event.target.value = event.target.value
          .replace(/,/gi, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

        // ریست اعتبارسنجی
        this.newNDebit_Invalid = false;
        this.newNCredit_Invalid = false;
      }
      // این خط باعث می شود ویو متوجه تغییر بشود
      event.target.dispatchEvent(new Event("input"));
    },

    // درج فقط عدد مجاز است و جستجوی کد حساب در لیست
    onlyNumberAndFilterHesabCode($event) {
      if($event != undefined){
        if ($event.key === "+") {
          this.ShowModal("HesabCode");
          return $event.preventDefault();
        } else {
          if (!/\d/.test($event.key)) {
            return $event.preventDefault();
          } else {
            this.isShowFilterHesabCode = true;
            this.isShowFilterTarafHesab = false;
            this.isShowModalBaseUsePlace = false;
            this.isShowFilterBaseAgreement = false;
            // ریست اعتبارسنجی
            this.newNAccCode_NCode_Invalid = false;
          }
        }
      } else {
        this.isShowFilterHesabCode = true;
      }
      setTimeout(() => {
        this.RandomNumber = Math.random() * 10;
      }, 100);
    },

    // درج فقط عدد مجاز است و جستجوی کد طرف حساب در لیست
    onlyNumberAndFilterTarafHesab($event) {
      if($event != undefined){
        if ($event.key === "+") {
          this.ShowModal("TarafHesab");
          return $event.preventDefault();
        } else {
          if (!/\d/.test($event.key)) {
            return $event.preventDefault();
          } else {
            this.isShowFilterTarafHesab = true;
            this.isShowFilterHesabCode = false;
            this.isShowModalBaseUsePlace = false;
            this.isShowFilterBaseAgreement = false;
            // ریست اعتبارسنجی
            this.newNPerID_NPerID_Invalid = false;
          }
        }
      } else {
        this.isShowFilterTarafHesab = true;
      }
      setTimeout(() => {
        this.RandomNumber = Math.random() * 10;
      }, 100);
    },

    // درج فقط عدد مجاز است و جستجوی کد مرکز هزینه در لیست
    onlyNumberAndFilterBaseUsePlace($event) {
      if($event != undefined){
        if ($event.key === "+") {
          this.ShowModal("BaseUsePlace");
          return $event.preventDefault();
        } else {
          if (!/\d/.test($event.key) && $event.key !== ".") {
            return $event.preventDefault();
          } else {
            this.isShowFilterBaseUsePlace = true;
            this.isShowFilterTarafHesab = false;
            this.isShowFilterHesabCode = false;
            this.isShowFilterBaseAgreement = false;
            // ریست اعتبارسنجی
            this.newBaseUserPlace_NCode_Invalid = false;
          }
        }
      } else {
        this.isShowFilterBaseUsePlace = true;
      }
      setTimeout(() => {
        this.RandomNumber = Math.random() * 10;
      }, 100);
    },

    // درج فقط عدد مجاز است و جستجوی کد پروژه در لیست
    onlyNumberAndFilterBaseAgreement($event) {
      if($event != undefined){
        if ($event.key === "+") {
          this.ShowModal("BaseAgreement");
          return $event.preventDefault();
        } else {
          if (!/\d/.test($event.key) && $event.key !== ".") {
            return $event.preventDefault();
          } else {
            this.isShowFilterBaseAgreement = true;
            this.isShowFilterBaseUsePlace = false;
            this.isShowFilterTarafHesab = false;
            this.isShowFilterHesabCode = false;
            // ریست اعتبارسنجی
            this.newBaseAgreement_NAgrID_Invlid = false;
          }
        }
      } else {
        this.isShowFilterBaseAgreement = true;
      }
      setTimeout(() => {
        this.RandomNumber = Math.random() * 10;
      }, 100);
    },

    // تابع مدیریت کلید میانبرها داخل سند
    keyPressValue(keyvalue) {
      // console.log({
      //   tabActive: this.tabActive,
      //   TabID: this.tabData.TabID,
      //   key: keyvalue.key,
      // });
      if (this.tabActive == this.tabData.TabID) {
        // اگر در سند کلید تب فشرده شود
        if (keyvalue.key === "Tab") {
          // مخفی کردن تمام لیست های کشویی
          this.HideFilterModal();
        }
        // اگر کلیدهای جهت نما فعال باشد
        if (this.ArrowKeyEnable) {
          if (keyvalue.key === "ArrowUp") {
            // حرکت رو به بالا
            let nioid = this.selectRowID;
            let index = this.AccDocData.ListTbAccDocRecord.findIndex(
              (itme) => itme.NIOId == nioid
            );
            if (index - 1 >= 0) {
              this.selectRowID =
                this.AccDocData.ListTbAccDocRecord[index - 1].NIOId;
            }
          }
          if (keyvalue.key === "ArrowDown") {
            // حرکت رو به پایین
            let nioid = this.selectRowID;
            let index = this.AccDocData.ListTbAccDocRecord.findIndex(
              (itme) => itme.NIOId == nioid
            );
            if (index + 1 < this.AccDocData.ListTbAccDocRecord.length) {
              this.selectRowID =
                this.AccDocData.ListTbAccDocRecord[index + 1].NIOId;
            }
          }
          if (keyvalue.key === " ") {
            // انتخاب سطر جاری به روش تیک زدن چک باکس
            if (
              this.checkedRowSelect.find(
                (element) => element == this.selectRowID
              ) != undefined
            ) {
              // حذف از لیست چک باکس
              let currentRow = this.selectRowID;
              var arrayTemp = this.checkedRowSelect.filter(function (ele) {
                return ele != currentRow;
              });
              this.checkedRowSelect = arrayTemp;
            } else {
              // افزودن به لیست چک باکس
              this.checkedRowSelect.push(this.selectRowID);
            }
          }
        }

        // اگر کلید میانبرها فعال باشد
        if (this.HotKeyEnable && keyvalue.altKey == true) {
          if (keyvalue.key === "n" || keyvalue.key === "د") {
            // درج سطر جدید
            this.callNewRow();
          } else if (keyvalue.key === "c" || keyvalue.key === "ز") {
            // انصراف از درج سطر جدید یا ویرایش سطر
            if (this.checkNewRow == true) {
              this.cancelNewRow();
            } else {
              this.cancelEditRow(this.editNIOId);
            }
          } else if (keyvalue.key === "s" || keyvalue.key === "س") {
            // ذخیره سطر جدید یا ذخیره ویرایش سطر
            if (this.checkNewRow == true) {
              this.saveNewRow();
            } else {
              this.saveEditRow(this.editNIOId);
            }
          } else if (keyvalue.key === "e" || keyvalue.key === "ث") {
            // ویرایش سطر
            if (this.selectRowID != 0) {
              this.callEditRow(this.selectRowID);
            }
          } else if (keyvalue.key === "d" || keyvalue.key === "ی") {
            // حذف سطر
            if (this.selectRowID != 0) {
              this.deleteRow();
            }
          } else if (keyvalue.key === "m" || keyvalue.key === "ئ") {
            // جابجایی مبلغ
            if (this.selectRowID != 0) {
              this.callMoveAmount(this.selectRowID);
            }
          } else if (keyvalue.key === "i" || keyvalue.key === "ه") {
            // کپی این سطر
            if (this.selectRowID != 0) {
              this.callCopyAndNewRow(this.selectRowID);
            }
          }
        }

        // اگر سطری در حال ویرایش یا درج نبود
        // در صورت فشردن اینتر ، سطر به حالت ویرایش برود
        // if (this.ArrowKeyEnable) {
        //   if (keyvalue.key === "Enter") {
        //     // ویرایش سطر
        //     if (this.selectRowID != 0) {
        //       this.callEditRow(this.selectRowID);
        //     }
        //   }
        // }

        // اگر مودال در حالت نمایش نبود
        if (this.HotKeyEnable == true) {
          if (keyvalue.key === "Escape") {
            // انصراف از درج سطر جدید یا ویرایش سطر
            if (this.checkNewRow == true) {
              this.cancelNewRow();
            } else {
              this.cancelEditRow(this.editNIOId);
            }
          }

          // اگر سطری در حال ویرایش یا درج نبود و مودال در حالت نمایش نبود
          if (this.ArrowKeyEnable && this.HotKeyEnable) {
            // انتقال فوکوس به کادر جستجو پیشرفته در سند
            if (keyvalue.key === "F3") {
              setTimeout(() => {
                $("#textSanadSearch-" + this.tabData.TabID).focus();
              }, this.setTimeoutDelay);
            }
            // ذخیره کلی سند
            if (keyvalue.key === "F4"){
              this.SaveTbDocInfo(this.tabData.TabID);
            }
          }
        }
      }
    },

    // جابجایی مبلغ
    callMoveAmount(NIOId) {
      // جابجایی مبلغ بدهکار با بستانکار
      let index = this.AccDocData.ListTbAccDocRecord.findIndex(
        (itme) => itme.NIOId == NIOId
      );
      if (index != -1) {
        let numTemp = this.AccDocData.ListTbAccDocRecord[index].NDebit;
        this.AccDocData.ListTbAccDocRecord[index].NDebit =
          this.AccDocData.ListTbAccDocRecord[index].NCredit;
        this.AccDocData.ListTbAccDocRecord[index].NCredit = numTemp;
        // در سند تغییر رخ داده است
        this.setChangeAccDocData();
        // محاسبه جمع ستون های بدهکار و بستانکار
        this.calcSumAmountRow();
        // نمایش پیام جابجایی مبلغ
        this.$store.dispatch("notify", {
          notText: "مبلغ بدهکار و بستانکار جابجا شد .",
          timeOut: 2500,
        });
      }
    },

    // کپی این سطر
    callCopyAndNewRow(NIOId) {
      // کپی این سطر
      let index = this.AccDocData.ListTbAccDocRecord.findIndex(
        (itme) => itme.NIOId == NIOId
      );
      if (index != -1) {
        // لغو ویرایش های قبلی
        this.cancelEditRow(this.editNIOId);
        // فعال سازی درج سطر جدید
        this.checkNewRow = true;
        // غیرفعال سازی کلید میانبرهای جهت نما
        this.ArrowKeyEnable = false;

        // مقدار دهی با مقادیر سطر جاری
        this.newNAccCode_NCode =
          this.AccDocData.ListTbAccDocRecord[index].NAccCode;
        this.newNAccCode_SDesc =
          this.AccDocData.ListTbAccDocRecord[index].SDesc;
        this.newNAccCode_NAccType =
          this.AccDocData.ListTbAccDocRecord[index].NAccType;

        this.newNPerID_NPerID =
          this.AccDocData.ListTbAccDocRecord[index].NPerID;
        this.newNPerID_NPerName =
          this.AccDocData.ListTbAccDocRecord[index].NPerName;
        this.newNPerID_NPerLastName =
          this.AccDocData.ListTbAccDocRecord[index].NPerLastName;
        this.newNPerID_NPerType =
          this.AccDocData.ListTbAccDocRecord[index].NPerType;

        this.newBaseUserPlace_NCode =
          this.AccDocData.ListTbAccDocRecord[index].NUsePlace;
        this.newBaseAgreement_NAgrID =
          this.AccDocData.ListTbAccDocRecord[index].NAgrID;

        this.newSAccDesc = this.AccDocData.ListTbAccDocRecord[index].SAccDesc;
        // در عمل کپی از سطر جاری جای بدهکار و بستانکار جابجا می شود
        this.newNDebit = this.AccDocData.ListTbAccDocRecord[
          index
        ].NCredit.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        this.newNCredit = this.AccDocData.ListTbAccDocRecord[
          index
        ].NDebit.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

        // انتقال فوکوس به داخل کادر کد حساب
        this.ChangeFocusText("NCode");
      }
    },

    // حذف اطلاعات سند از سرور
    async deleteDataFromServer() {
      // if (
      //   confirm(
      //     "شما تقاضا حذف سند شماره " + this.AccDocData.NDocNu + " را کرده اید . آیا ادامه می دهید؟"
      //   )
      // ) {
      //   let token = await this.$store.getters.getUserData.token;
      //   var check = await this.$store.dispatch("deleteDocInfoFromServer", {
      //     AccDocID: {
      //       NId: this.AccDocData.NId,
      //       NDocNu: this.AccDocData.NDocNu,
      //     },
      //     token: token,
      //   });
      //   if (check == true) {
      //     // حذف اطلاعات محلی
      //     this.removeLocalData(this.tabData.TabID);
      //     // انتقال فوکوس به تب قبلی
      //     // ارسال شماره تب به رویداد تغییر تب فعال
      //     BusEvent.$emit("ChangeTabActive", this.tabData.TabID - 1);
      //     // حذف تب از لیست تب ها
      //     await this.$store.dispatch("deleteTabFromTabList", {
      //       tabID: this.tabData.TabID,
      //     });
      //   }
      // }

      swal({
        title: "حذف سند " + this.AccDocData.NDocNu,
        text:
          "شما تقاضا حذف سند شماره " +
          this.AccDocData.NDocNu +
          " را کرده اید . آیا ادامه می دهید؟",
        icon: "warning", // success, warning, error, info
        buttons: {
          cancel: "انصراف",
          ok: "بله سند حذف شود",
        },
        // content: "input",
        // closeModal: false,
        // dangerMode: true,
      }).then(async (value) => {
        if (value) {
          let token = await this.$store.getters.getUserData.token;
          var check = await this.$store.dispatch("deleteDocInfoFromServer", {
            AccDocID: {
              NId: this.AccDocData.NId,
              NDocNu: this.AccDocData.NDocNu,
            },
            token: token,
          });
          if (check == true) {
            // حذف اطلاعات محلی
            this.removeLocalData(this.tabData.TabID);
            // انتقال فوکوس به تب قبلی
            // ارسال شماره تب به رویداد تغییر تب فعال
            BusEvent.$emit("ChangeTabActive", this.tabData.TabID - 1);
            // اعلام حذف سند به فرم لیست اسناد جهت بروزرسانی لیست در حال نمایش
            BusEvent.$emit("CallRestDocList_Tab1_ListSanad", this.AccDocData.NId);
            // حذف تب از لیست تب ها
            await this.$store.dispatch("deleteTabFromTabList", {
              tabID: this.tabData.TabID,
            });
          }
        }
      });
    },

    // ثبت وجود تغییرات در سند
    setChangeAccDocData(blnCheckSave = true) {
      // اگر سند از نوع دائم نبود تغییرات را نگه دار
      if (this.AccDocData.BStatus == false) {
        // در سند تغییر رخ داده است
        // در صورتی که در اطلاعات سربرگ سند تغییری رخ دهد اجرا می شود
        this.AccDocData.CheckChangeData = true;
        // اعلام مشاهده تغییرات به تب جاری
        this.setChangeDataInTab(this.tabData.TabID, blnCheckSave);
        // اگر سند جدید است : غیرفعال کردن شماره و شناسه سند
        this.setDisabledDocID();
      }
    },

    // اگر سند جدید است و تغییری کرده است
    // شماره و شناسه سند غیرفعال گردد
    setDisabledDocID() {
      // if (this.AccDocData.NId == 0 && this.AccDocData.NDocNu == 0){
      // غیرفعال کردن شماره و شناسه سند
      this.checkDisabledDocID = true;
      // }
    },

    // ذخیره اطلاعات سند
    async SaveTbDocInfo(tabid) {
      // آیا شناسه تب مربوط به این تب می باشد ؟
      // این تابع از خارج از کامپوننت هم فراخوانی می شود
      if (tabid == this.tabData.TabID) {
        // آیا سند از نوع موقت است ؟
        if (this.AccDocData.BStatus == false) {
          // آیا نوع سند مجاز به ذخیره می باشد ؟
          var checkDocType = await this.$store.dispatch(
            "checkDocTypeBeSaved",
            this.AccDocData.NDocType
          );
          if (checkDocType.Check == true) {
            // آیا رکوردی برای سند درج شده است ؟
            if (this.AccDocData.ListTbAccDocRecord.length > 0) {
              // آیا سند تراز می باشد ؟
              if (this.SumAmountRow.AlignmentStatus == false) {
                // عدم ذخیره سند : سند تراز نمی باشند
                this.$store.dispatch("notify", {
                  notText: "عدم ثبت سند : سند تراز نمی باشند !",
                  timeOut: 2500,
                });
              } else {
                // درج تاریخ و شرح سند الزامی است
                if (
                  this.AccDocData.SDocDate != "" &&
                  this.AccDocData.SDocDesc != ""
                ) {
                  // اگر مقادیر شماره و شناسه سند خالی بود
                  // با صفر مقدار دهی شود تا خطای ارتباط با سرور ندهد
                  if (this.AccDocData.NDocNu === "") this.AccDocData.NDocNu = 0;
                  if (this.AccDocData.NId === "") this.AccDocData.NId = 0;

                  // دریافت توکن احراز هویت
                  let token = await this.$store.getters.getUserData.token;
                  // ذخیره سند در سرور
                  var check = await this.$store.dispatch("SaveTbDocInfo", {
                    AccDocData: this.AccDocData,
                    token: token,
                  });
                  if (check.Status == true) {
                    // سند با موفقیت در سرور ذخیره شد
                    // حذف اطلاعات محلی از مرورگر
                    this.removeLocalData(this.tabData.TabID);
                    // ذخیره شماره سند و شناسه سند جدید در متغییر محلی
                    this.AccDocData.NId = check.NId;
                    this.AccDocData.NDocNu = check.NDocNu;
                    // تغییر شماره و شناسه سند در تب جاری
                    this.tabData.NId = this.AccDocData.NId;
                    this.tabData.NDocNu = this.AccDocData.NDocNu;
                    // تنظیم وضعیت سند به ذخیره شده
                    // جهت نمایش دکمه خروج در سربرگ سند
                    this.AccDocData.CheckChangeData = false;
                    // وجود تغییرات به مخزن اصلی اعمال گردد
                    this.setChangeDataInTab(this.tabData.TabID, false);
                    // ذخیره شماره سند جدید در متغییر محلی جهت ذخیره سازی لوکال
                    this.tabIDInChild = check.NDocNu;
                    // اعلام حذف سند به فرم لیست اسناد جهت بروزرسانی لیست در حال نمایش
                    BusEvent.$emit("CallRestDocList_Tab1_ListSanad", check.NId, false, this.AccDocData);
                  }
                } else {
                  // عدم ذخیره سند : درج تاریخ و شرح سند الزامی است
                  this.$store.dispatch("notify", {
                    notText: "عدم ثبت سند : درج تاریخ و شرح سند الزامی است !",
                    timeOut: 2500,
                  });
                }
              }
            } else {
              this.$store.dispatch("notify", {
                notText:
                  "برای این سند ، هیچ سطری ثبت نشده است !\nشما مجاز به ذخیره سند خالی نمی باشید .",
                timeOut: 2500,
              });
            }
          } else {
            // عدم ذخیره سند : نوع سند مجاز به ذخیره نمی باشد
            this.$store.dispatch("notify", {
              notText:
                "عدم ثبت سند !\n شما مجاز به ذخیره سند از نوع " +
                checkDocType.SDocType +
                " نمی باشید .",
              timeOut: 2500,
            });
          }
        } else {
          // سند از نوع دائم است و کاربر مجاز به ویرایش نمی باشد
          this.$store.dispatch("notify", {
            notText:
              "عدم ویرایش سند !\n شما مجاز به ویرایش سند از نوع دائم نمی باشید .",
            timeOut: 2500,
          });
        }
      }
    },

    // ذخیره اطلاعات سند قبل از خروج از آن
    async SaveTbDocInfoBeforExit() {
      // اگر سند تغییری داشت و رکوردی داشت
      if (
        this.AccDocData.CheckChangeData == true &&
        this.AccDocData.ListTbAccDocRecord.length > 0
      ) {
        await this.SaveTbDocInfo(this.tabData.TabID);
      }
    },

    // ذخیره اطلاعات در مرورگر
    saveLocalData() {
      const parsed = JSON.stringify(this.AccDocData);
      localStorage.setItem("Paresh_docRow_" + this.tabIDInChild, parsed);
      this.tabData.LocalData = true;
    },

    // حذف اطلاعات از مرورگر
    removeLocalData(tabID) {
      if (tabID == this.tabData.TabID) {
        localStorage.removeItem("Paresh_docRow_" + this.tabIDInChild);
        this.tabData.LocalData = false;
      }
    },
  },
  // // اعتبار سنجی مقادیر
  // validations: {
  //   // اعتبار سنجی کد حساب
  //   newNAccCode_NCode: {
  //     numeric, // عددی
  //     required, // اجباری
  //     minValue: minValue(1), // حداقل مقدار 1
  //     integer, // عدد صحیح
  //   },

  //   // اعتبار سنجی شرح حساب
  //   newSAccDesc: {
  //     required, // اجباری
  //   },

  //   // اعتبار سنجی مقدار بدهکار
  //   newNDebit: {
  //     required, // اجباری
  //     // numeric,
  //     // minValue: minValue(0),
  //   },

  //   // اعتبار سنجی مقدار بستانکار
  //   newNCredit: {
  //     required, // اجباری
  //     //numeric,
  //     //minValue: minValue(0),
  //   },
  // },
  watch: {
    // در صورت تغییر تب فعال ، وضعیت ویرایش غیرفعال شود
    tabActive: function () {
      this.cancelEditRow(this.editNIOId);
    },
    // در صورت ثبت مقدار در ستون بدهکار ، ستون بستانکار خالی شود
    newNDebit: function (value) {
      if (value != "0") {
        this.newNCredit = 0;
      }
    },
    // در صورت ثبت مقدار در ستون بستانکار ، ستون بدهکار خالی شود
    newNCredit: function (value) {
      if (value != "0") {
        this.newNDebit = 0;
      }
    },
    // تغییری در مقدار تاریخ رخ داده است
    SDocDateTemp: async function (value) {
      if (value != "") {
        // بررسی مطابقت سال با سال مالی
        if (
          value.toString().substring(0, 4) != this.$store.getters.getYearActive
        ) {
          // اگر سال با سال مالی مطابقت نداشت
          this.showAlarmNotSetDate("تاریخ درج شده با سال مالی مطابقت ندارد !");
        } else {
          // سال با سال مالی مطابقت دارد
          let checkSal = await this.$store.getters.getDateLastDoc;
          if (parseInt(value.replace(/\//g, "")) < checkSal) {
            // آیا تاریخ سند از تاریخ آخرین سند کمتر است ؟
            if (this.AccDocData.SDocDate != value) {
              this.showAlarmNotSetDate(
                "تاریخ درج شده از تاریخ آخرین سند ، کمتر است !"
              );
            }
          } else {
            this.AlarmNotSetDate = false;
          }
        }
      }
      // ذخیره تغییرات در مدل اصلی
      this.AccDocData.SDocDate = value;
    },
  },
  created() {
    // رویداد ذخیره اطلاعات سند
    // این رویداد توسط کامپاننت سربرگ سند فراخوانی می شود
    BusEvent.$on("SaveTbDocInfo", this.SaveTbDocInfo);
    // رویداد حذف اطلاعات محلی
    BusEvent.$on("removeLocalData", this.removeLocalData);
    // رویداد دریافت کلید میانبرها
    BusEvent.$on("keyPressValue", this.keyPressValue);
  },
  beforeDestroy() {
    // حذف رویدادها از حافظه
    BusEvent.$off("SaveTbDocInfo", this.SaveTbDocInfo);
    BusEvent.$off("removeLocalData", this.removeLocalData);
    BusEvent.$off("keyPressValue", this.keyPressValue);
  },
};
</script>

<style scoped>
/* استایل اعتبارسنجی */
.invalid {
  border: 1px solid red !important;
  box-shadow: 0 0 5px red !important;
  background-color: rgb(255, 242, 56) !important;
}

/* استایل انتخاب سطر */
.selRow {
  color: #7e489c;
  background-color: #fbff94;
}

.selRow td {
  background: none;
}

.selRow .text-info,
.text-primary {
  color: #7e489c !important;
}

/* استایل نمایش سطرها */
.selShow {
  color: #17a2b8;
  background-color: white;
}

.rowBoxShadow {
  box-shadow: rgb(126 72 156 / 15%) 0px -2px 3px;
}

.rowCursorPointer {
  cursor: pointer;
}

.tdGradient {
  background: linear-gradient(rgba(233, 233, 233, 0.4), rgba(255, 255, 255, 1));
}

.tdGradient2 {
  background: linear-gradient(rgba(233, 233, 233, 0.4),
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 1));
}

.shortText {
  padding: 0 5px !important;
  max-width: 200px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/NewAccDoc/NewAccDoc.vue